// ============================================================================
// UTOPIA — Mostra virtuale 3D (Flower Garden)
// ----------------------------------------------------------------------------
// Struttura del file (IIFE unica, in ordine di apparizione):
//  1. Configurazione (dimensioni stanza, movimento, luci, audio, prodotti)
//  2. Overlay d'ingresso + audio engine sintetizzato (Web Audio API)
//  3. Setup scena Three.js: camera, renderer, pavimento/muri, texture
//     procedurali (erba, terra, nuvole, petali dei fiori)
//  4. Elementi della stanza: piante/vasi (Et/Pt), robot impollinatori (Rt),
//     torri con "pioggia" luminosa (Ht), bracci robotici piantatori (It),
//     schermi laterali con testo animato (ft/drawTerminalScreen)
//  5. Sprite dei fiori (et) + drone che pattugliano/ispezionano/"rapiscono"
//     i fiori (Yt/Zt)
//  6. Cornici prodotto sui muri (finestre stile retro) + cartello uscita
//  7. Controlli: drag-to-look, joystick virtuale, tastiera, raycasting per
//     l'interazione con le opere
//  8. Ciclo giorno/notte, ascoltatore audio 3D, stato dei fiori
//     (updateDayNightCycle / updateAudioListener / updateFlowers)
//  9. Loop di animazione (animate) e listener di resize/uscita/carrello
// ----------------------------------------------------------------------------
// Revisione 11/10/2026:
//  - joystick nascosto finché non si entra e quando pannello/uscita sono
//    aperti (prima stava sopra a tutto e copriva i tasti)
//  - prezzi, varianti, immagini e disponibilità letti live da Shopify
//    (window.ROOM01_PRODUCTS, generato in Liquid nel template); l'array
//    qui sotto resta come fallback
//  - "Add to cart" aggiunge davvero al carrello (variantId compilati)
//  - foto dell'opera nel pannello, link al carrello dopo l'aggiunta
//  - interfaccia tutta in inglese
//  - banner errori leggibile dal cliente, chiudibile, a scomparsa
//  - chi si è già iscritto entra direttamente (localStorage)
//  - metà delle texture dei fiori e pixel ratio ridotto su mobile
// Revisione 12/10/2026 — resa cinematografica:
//  - niente tone mapping qui: sulla palette pastello della stanza l'ACES
//    sbiadiva i colori. Il look da film lo danno vignetta, grana e
//    viraggio leggero (overlay #room-mood nello snippet)
//  - sguardo con inerzia (CINE.lookSmoothing): la camera segue il dito o
//    il mouse con un leggero ritardo, come una ripresa a mano
//  - respiro della camera: oscillazione verticale di ~1 cm da fermi
// Revisione 12/10/2026 (2):
//  - email ricordata già al click su "Enter": si entra direttamente anche
//    se Shopify non torna con ?entered=1 (captcha, email già iscritta)
//  - sguardo al tocco invertito, stile Street View (mouse invariato)
// ============================================================================
!(function () {
  // Alcuni temi Shopify applicano un transform CSS (es. animazioni di
  // comparsa allo scroll) alla sezione che contiene questo blocco Custom
  // Liquid. Un transform su un antenato rompe silenziosamente il
  // position:fixed dei suoi discendenti (diventa relativo all'antenato
  // invece che alla viewport). Spostando gli overlay come figli diretti
  // di <body> li rendiamo immuni a questo problema, qualunque sia il
  // tema o la sezione in cui viene inserito il blocco.
  [
    "err-banner",
    "entry",
    "hud",
    "move-hint",
    "joystick-zone",
    "panel",
    "exit-confirm",
  ].forEach((id) => {
    const el = document.getElementById(id);
    el && el.parentElement !== document.body && document.body.appendChild(el);
  });
  // Mostra/nasconde il joystick. Resta nascosto finché il visitatore non
  // entra e ogni volta che è aperto il pannello di un'opera o la conferma
  // di uscita, così non si sovrappone mai ai loro pulsanti.
  function setJoystick(on) {
    const js = document.getElementById("joystick-zone");
    js && js.style.setProperty("display", on ? "block" : "none", "important");
  }
  // Stili del joystick impostati via JS con !important, più forti di
  // qualunque foglio di stile esterno del tema. z-index 25: sopra la scena
  // e l'HUD (20), sotto pannello (30), conferma uscita (40) e ingresso (50).
  (function () {
    const js = document.getElementById("joystick-zone");
    if (!js) return;
    const force = (el, rules) => {
      if (!el) return;
      for (const prop in rules)
        el.style.setProperty(prop, rules[prop], "important");
    };
    force(js, {
      position: "fixed",
      left: "max(20px, env(safe-area-inset-left))",
      bottom: "max(20px, env(safe-area-inset-bottom))",
      width: "120px",
      height: "120px",
      "z-index": "25",
      display: "none",
      visibility: "visible",
      opacity: "1",
      "pointer-events": "auto",
    });
    force(document.getElementById("joystick-base"), {
      position: "absolute",
      inset: "0",
      "border-radius": "50%",
      background: "rgba(255,255,255,0.32)",
      border: "3px solid rgba(255,255,255,0.9)",
      "box-shadow":
        "0 2px 12px rgba(0,0,0,0.4), inset 0 0 0 1px rgba(0,0,0,0.25)",
      display: "block",
      visibility: "visible",
      opacity: "1",
    });
    force(document.getElementById("joystick-knob"), {
      position: "absolute",
      left: "50%",
      top: "50%",
      width: "54px",
      height: "54px",
      margin: "-27px 0 0 -27px",
      "border-radius": "50%",
      background: "rgba(17,17,17,0.9)",
      border: "2px solid rgba(255,255,255,0.95)",
      "box-shadow": "0 2px 8px rgba(0,0,0,0.4)",
      display: "block",
      visibility: "visible",
      opacity: "1",
    });
  })();
  const t = { width: 32, depth: 32, height: 5.5 },
    e = {
      eyeHeight: 1.68,
      moveSpeed: 3.2,
      wallMargin: 0.6,
      spawn: { x: -6, z: 12 },
      lookSensitivity: 0.0028,
    },
    n = {
      ambientIntensity: 0.75,
      sunIntensity: 0.95,
      droneIntensity: 0.6,
      droneInspectIntensity: 1.9,
    },
    a = { cycleSeconds: 300, moonIntensity: 0.55 },
    o = { masterVolume: 0.4 },
    i = { count: 6 },
    s = { bandHeight: 1.5, flowerCount: 13 },
    r = { resolution: 512 },
    c = "https://stenjs.com",
    // Fallback statico. Prezzo, variante, immagine, URL e disponibilità
    // vengono sovrascritti dai dati live (vedi sotto) quando disponibili.
    l = [
      {
        handle: "flowers-exe-file_01",
        title: "FLOWERS.EXE — file_01",
        meta: "Digital art on Fine Art print — A4, Open Edition, 2026",
        price: "40€",
        url: "https://stenjs.com/products/flowers-exe-file_01",
        variantId: 54871330455881,
        imageUrl: "https://stenjs.com/cdn/shop/files/IMG_1497.jpg?v=1784287874",
        windowName: "FLOWERS_01.EXE",
        color: 16230596,
      },
      {
        handle: "flowers-exe-file_02",
        title: "FLOWERS.EXE — file_02",
        meta: "Digital art on Fine Art print — A4, Open Edition, 2026",
        price: "40€",
        url: "https://stenjs.com/products/flowers-exe-file_02",
        variantId: 54871330718025,
        imageUrl: "https://stenjs.com/cdn/shop/files/IMG_1501.jpg?v=1784287875",
        windowName: "FLOWERS_02.EXE",
        color: 10216804,
      },
      {
        handle: "flowers-exe-file_03",
        title: "FLOWERS.EXE — file_03",
        meta: "Digital art on Fine Art print — A4, Open Edition, 2026",
        price: "40€",
        url: "https://stenjs.com/products/flowers-exe-file_03",
        variantId: 54896656646473,
        imageUrl: "https://stenjs.com/cdn/shop/files/IMG_1502.jpg?v=1784287874",
        windowName: "FLOWERS_03.EXE",
        color: 9358054,
      },
      {
        handle: "flowers-exe-file_04",
        title: "FLOWERS.EXE — file_04",
        meta: "Digital art on Fine Art print — A4, Open Edition, 2026",
        price: "40€",
        url: "https://stenjs.com/products/flowers-exe-file_04",
        variantId: 54896786178377,
        imageUrl: "https://stenjs.com/cdn/shop/files/IMG_1509.jpg?v=1784642330",
        windowName: "FLOWERS_04.EXE",
        color: 16757084,
      },
      {
        handle: "flowers-exe-file_05",
        title: "FLOWERS.EXE — file_05",
        meta: "Digital art on Fine Art print — A4, Open Edition, 2026",
        price: "40€",
        url: "https://stenjs.com/products/flowers-exe-file_05",
        variantId: 54896801513801,
        imageUrl: "https://stenjs.com/cdn/shop/files/IMG_1495.jpg?v=1784642479",
        windowName: "FLOWERS_05.EXE",
        color: 13215474,
      },
      {
        handle: "flowers-exe-file_06",
        title: "FLOWERS.EXE — file_06",
        meta: "Digital art on Fine Art print — A4, Open Edition, 2026",
        price: "40€",
        url: "https://stenjs.com/products/flowers-exe-file_06",
        variantId: 54896806625609,
        imageUrl: "https://stenjs.com/cdn/shop/files/IMG_1504.jpg?v=1784642330",
        windowName: "FLOWERS_06.EXE",
        color: 16743034,
      },
      {
        handle: "flowers-exe-file_07",
        title: "FLOWERS.EXE — file_07",
        meta: "Digital art on Fine Art print — A4, Open Edition, 2026",
        price: "40€",
        url: "https://stenjs.com/products/flowers-exe-file_07",
        variantId: 54896808853833,
        imageUrl: "https://stenjs.com/cdn/shop/files/IMG_1498.jpg?v=1784287874",
        windowName: "FLOWERS_07.EXE",
        color: 16735650,
      },
      {
        handle: "flowers-exe-file_08",
        title: "FLOWERS.EXE — file_08",
        meta: "Digital art on Fine Art print — A4, Open Edition, 2026",
        price: "40€",
        url: "https://stenjs.com/products/flowers-exe-file_08",
        variantId: 54896816980297,
        imageUrl: "https://stenjs.com/cdn/shop/files/IMG_1506.jpg?v=1784287856",
        windowName: "FLOWERS_08.EXE",
        color: 16769658,
      },
      {
        handle: "flowers-exe-file_09",
        title: "FLOWERS.EXE — file_09",
        meta: "Digital art on Fine Art print — A4, Open Edition, 2026",
        price: "40€",
        url: "https://stenjs.com/products/flowers-exe-file_09",
        variantId: 54896818913609,
        imageUrl: "https://stenjs.com/cdn/shop/files/IMG_1510.jpg?v=1784642330",
        windowName: "FLOWERS_09.EXE",
        color: 11569401,
      },
      {
        handle: "flowers-exe-file_10",
        title: "FLOWERS.EXE — file_10",
        meta: "Digital art on Fine Art print — A4, Open Edition, 2026",
        price: "40€",
        url: "https://stenjs.com/products/flowers-exe-file_10",
        variantId: 54896825205065,
        imageUrl: "https://stenjs.com/cdn/shop/files/IMG_1492.jpg?v=1784642330",
        windowName: "FLOWERS_10.EXE",
        color: 5102016,
      },
      {
        handle: "flowers-exe-file_11",
        title: "FLOWERS.EXE — file_11",
        meta: "Digital art on Fine Art print — A4, Open Edition, 2026",
        price: "40€",
        url: "https://stenjs.com/products/flowers-exe-file_11",
        variantId: 54896828907849,
        imageUrl: "https://stenjs.com/cdn/shop/files/IMG_1507.jpg?v=1784642330",
        windowName: "FLOWERS_11.EXE",
        color: 16752506,
      },
      {
        handle: "flowers-exe-file_12",
        title: "FLOWERS.EXE — file_12",
        meta: "Digital art on Fine Art print — A4, Open Edition, 2026",
        price: "40€",
        url: "https://stenjs.com/products/flowers-exe-file_12",
        variantId: 54896831037769,
        imageUrl: "https://stenjs.com/cdn/shop/files/IMG_1508.jpg?v=1784642330",
        windowName: "FLOWERS_12.EXE",
        color: 12835050,
      },
    ],
    d = document.getElementById("email"),
    h = document.getElementById("enter-btn");
  // Dati live da Shopify (generati in Liquid nel template della pagina):
  // se cambi prezzo, foto o disponibilità di un prodotto in admin, la
  // stanza si aggiorna da sola. Se un prodotto manca, resta il fallback.
  (function () {
    const live = window.ROOM01_PRODUCTS || {};
    l.forEach((p) => {
      const d = live[p.handle];
      if (!d) return;
      ["variantId", "price", "imageUrl", "url", "available"].forEach((k) => {
        null != d[k] && "" !== d[k] && (p[k] = d[k]);
      });
    });
  })();
  const ENTRY_KEY = "utopia_room01_entered";
  let E = null,
    p = null,
    m = null,
    u = !1;
  function M(t) {
    if (!t || !E.createPanner) return null;
    const e = E.createPanner();
    return (
      (e.panningModel = "HRTF"),
      (e.distanceModel = "inverse"),
      (e.refDistance = 3),
      (e.maxDistance = 60),
      (e.rolloffFactor = 1.1),
      e.positionX
        ? ((e.positionX.value = t.x),
          (e.positionY.value = t.y),
          (e.positionZ.value = t.z))
        : e.setPosition && e.setPosition(t.x, t.y, t.z),
      e
    );
  }
  function f(t, e, n, a, o, i) {
    if (!E) return;
    const s = E.currentTime,
      r = E.createOscillator();
    ((r.type = a || "sine"),
      r.frequency.setValueAtTime(t, s),
      e && r.frequency.exponentialRampToValueAtTime(Math.max(1, e), s + n));
    const c = E.createGain();
    (c.gain.setValueAtTime(1e-4, s),
      c.gain.linearRampToValueAtTime(o || 0.1, s + 0.01),
      c.gain.exponentialRampToValueAtTime(1e-4, s + n));
    const l = M(i);
    (r.connect(c),
      l ? (c.connect(l), l.connect(p)) : c.connect(p),
      r.start(s),
      r.stop(s + n + 0.05));
  }
  function w(t, e, n, a) {
    if (!E) return;
    const o = E.currentTime,
      i = Math.max(1, Math.floor(E.sampleRate * t)),
      s = E.createBuffer(1, i, E.sampleRate),
      r = s.getChannelData(0);
    for (let t = 0; t < i; t++) r[t] = (2 * Math.random() - 1) * (1 - t / i);
    const c = E.createBufferSource();
    c.buffer = s;
    const l = E.createBiquadFilter();
    ((l.type = "lowpass"), (l.frequency.value = n || 1800));
    const d = E.createGain();
    d.gain.value = e || 0.06;
    const h = M(a);
    (c.connect(l),
      l.connect(d),
      h ? (d.connect(h), h.connect(p)) : d.connect(p),
      c.start(o));
  }
  function g() {
    f(600, 420, 0.06, "square", 0.045);
  }
  let T = !1;
  // Banner messaggi per il visitatore: si chiude con un tocco e, salvo
  // errori bloccanti (persist = true), sparisce da solo dopo 7 secondi.
  let errTimer = null;
  function y(t, persist) {
    const e = document.getElementById("err-banner");
    ((e.textContent = t), (e.style.display = "block"), clearTimeout(errTimer));
    persist ||
      (errTimer = setTimeout(() => {
        e.style.display = "none";
      }, 7e3));
  }
  document.getElementById("err-banner").addEventListener("click", function () {
    this.style.display = "none";
  });
  // Nasconde l'overlay d'ingresso, avvia l'audio e mostra il suggerimento
  // di movimento. Usata sia dopo un click valido su "Enter the exhibit"
  // (come fallback se il modulo non è disponibile) sia automaticamente al
  // ritorno da Shopify dopo l'iscrizione (vedi il controllo su ?entered=1
  // più sotto) e per chi si era già iscritto in una visita precedente.
  function dismissEntry() {
    (function () {
      if (!E)
        try {
          ((E = new (window.AudioContext || window.webkitAudioContext)()),
            (p = E.createGain()),
            (p.gain.value = u ? 0 : o.masterVolume),
            p.connect(E.destination),
            (m = E.createGain()),
            (m.gain.value = 0.045),
            m.connect(p));
          const t = E.createOscillator();
          ((t.type = "sine"), (t.frequency.value = 55), t.connect(m));
          const e = E.createOscillator();
          ((e.type = "sine"), (e.frequency.value = 110));
          const n = E.createGain();
          ((n.gain.value = 0.35), e.connect(n), n.connect(m));
          const a = E.createOscillator();
          ((a.type = "sine"), (a.frequency.value = 0.06));
          const i = E.createGain();
          ((i.gain.value = 0.018),
            a.connect(i),
            i.connect(m.gain),
            t.start(),
            e.start(),
            a.start());
        } catch (t) {
          console.warn("Audio non disponibile:", t);
        }
      // Senza un gesto dell'utente (ingresso automatico) il browser tiene
      // l'audio sospeso: lo riattiviamo al primo tocco/click.
      if (E && "suspended" === E.state) {
        const resume = () => {
          (E.resume(), document.removeEventListener("pointerdown", resume, !0));
        };
        document.addEventListener("pointerdown", resume, !0);
      }
    })();
    g();
    const e = document.getElementById("entry");
    (e.classList.add("hidden"),
      setTimeout(() => {
        e.style.display = "none";
      }, 650),
      (T = !0),
      setJoystick(!0),
      document.getElementById("move-hint").classList.add("show"),
      setTimeout(
        () => document.getElementById("move-hint").classList.remove("show"),
        5e3,
      ));
  }
  if (
    (h.addEventListener("click", () => {
      if (((t = d.value), !/\S+@\S+\.\S+/.test(t)))
        return ((d.style.borderBottomColor = "#b3110d"), void d.focus());
      var t;
      // Invio nativo del modulo: una VERA navigazione di pagina (non più un
      // trucco con iframe nascosto, che Shopify blocca esplicitamente con
      // "frame-ancestors: none" e che su Safari mobile viene comunque
      // ostacolato dalle regole sui cookie di terze parti). Shopify elabora
      // l'iscrizione e reindirizza da solo qui grazie al campo nascosto
      // "return_to" nel modulo — vedi il controllo su ?entered=1 più sotto.
      const entryFormEl = document.getElementById("entry-form");
      if (entryFormEl) {
        // L'ingresso si ricorda già qui, prima dell'invio: se il ritorno
        // da Shopify perde ?entered=1 (captcha, email già iscritta, redirect
        // diverso) alla visita dopo si entra comunque senza rifare il modulo.
        try {
          localStorage.setItem(ENTRY_KEY, "1");
        } catch (err) {}
        try {
          ((h.disabled = !0), (h.textContent = "Entering…"), entryFormEl.submit());
        } catch (err) {
          (console.error("Errore invio modulo email a Shopify:", err),
            dismissEntry());
        }
      } else {
        (console.warn(
          "Modulo #entry-form non trovato: email non inviata a Shopify.",
        ),
          dismissEntry());
      }
    }),
    d.addEventListener("input", () => {
      d.style.borderBottomColor = "";
    }),
    d.addEventListener("keydown", (t) => {
      "Enter" === t.key && (t.preventDefault(), h.click());
    }),
    "undefined" == typeof THREE)
  )
    throw (
      y(
        "The exhibit couldn't load. Check your connection, then reload the page.",
        !0,
      ),
      new Error("THREE not loaded")
    );
  // Ritorno da Shopify dopo un'iscrizione riuscita: niente da cliccare di
  // nuovo, si entra direttamente, si ricorda l'iscrizione e si ripulisce
  // l'URL. Chi si era già iscritto in passato entra subito.
  if (/[?&](entered=1|customer_posted=true)\b/.test(window.location.search)) {
    try {
      localStorage.setItem(ENTRY_KEY, "1");
    } catch (err) {}
    (dismissEntry(),
      window.history.replaceState(
        null,
        "",
        window.location.pathname + window.location.hash,
      ));
  } else {
    let alreadyIn = !1;
    try {
      alreadyIn = "1" === localStorage.getItem(ENTRY_KEY);
    } catch (err) {}
    alreadyIn && dismissEntry();
  }
  const R = t.width,
    H = t.depth,
    x = t.height,
    S = document.getElementById("canvas-wrap"),
    v = new THREE.Scene();
  ((v.background = new THREE.Color(8307954)),
    (v.fog = new THREE.Fog(12575743, 22, 150)));
  const I = new THREE.PerspectiveCamera(
    62,
    window.innerWidth / window.innerHeight,
    0.1,
    400,
  );
  I.rotation.order = "YXZ";
  const P = new THREE.WebGLRenderer({
    antialias: !0,
    logarithmicDepthBuffer: !0,
  });
  function b(t) {
    return Math.min(255, Math.max(0, t));
  }
  // Su touch screen il pixel ratio è limitato a 1.5: differenza visiva
  // minima, molto meno carico sulla GPU del telefono.
  const isTouch = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
  (P.setPixelRatio(Math.min(window.devicePixelRatio, isTouch ? 1.5 : 2)),
    P.setSize(window.innerWidth, window.innerHeight),
    (P.shadowMap.enabled = !0),
    (P.shadowMap.type = THREE.PCFSoftShadowMap),
    (P.outputEncoding = THREE.sRGBEncoding),
    S.appendChild(P.domElement));
  // --- Resa cinematografica ---------------------------------------------
  // exposure: luminosità generale dopo il tone mapping (1 = neutro).
  // lookSmoothing: più alto = camera più reattiva, più basso = più inerzia.
  const CINE = { exposure: 1, lookSmoothing: 12, breath: 0.011 };
  const C = 3066949,
    G = (function () {
      const t = r.resolution,
        e = document.createElement("canvas");
      e.width = e.height = t;
      const n = e.getContext("2d");
      ((n.fillStyle = "#f6f5f1"), n.fillRect(0, 0, t, t));
      for (let e = 0; e < 18; e++) {
        const e = Math.random() * t,
          a = Math.random() * t,
          o = 40 + 140 * Math.random(),
          i = n.createRadialGradient(e, a, 0, e, a, o);
        (i.addColorStop(0, Math.random() > 0.5 ? "#fbfaf7" : "#eeece6"),
          i.addColorStop(1, "transparent"),
          (n.globalAlpha = 0.05 + 0.06 * Math.random()),
          (n.fillStyle = i),
          n.beginPath(),
          n.arc(e, a, o, 0, 2 * Math.PI),
          n.fill());
      }
      n.globalAlpha = 1;
      const a = n.getImageData(0, 0, t, t),
        o = a.data;
      for (let t = 0; t < o.length; t += 4) {
        const e = 5 * (Math.random() - 0.5);
        ((o[t] = b(o[t] + e)),
          (o[t + 1] = b(o[t + 1] + e)),
          (o[t + 2] = b(o[t + 2] + e)));
      }
      n.putImageData(a, 0, 0);
      const i = new THREE.CanvasTexture(e);
      return (
        (i.wrapS = i.wrapT = THREE.RepeatWrapping),
        (i.encoding = THREE.sRGBEncoding),
        i
      );
    })();
  G.repeat.set(3, (x / R) * 3 * 2);
  const z = (function (t, e) {
    const n = r.resolution,
      a = document.createElement("canvas");
    a.width = a.height = n;
    const o = a.getContext("2d");
    ((o.fillStyle = `rgb(${t},${t},${t})`), o.fillRect(0, 0, n, n));
    const i = o.getImageData(0, 0, n, n),
      s = i.data;
    for (let n = 0; n < s.length; n += 4) {
      const a = b(t + (Math.random() - 0.5) * e * 2);
      ((s[n] = a), (s[n + 1] = a), (s[n + 2] = a));
    }
    o.putImageData(i, 0, 0);
    const c = new THREE.CanvasTexture(a);
    return ((c.wrapS = c.wrapT = THREE.RepeatWrapping), c);
  })(215, 12);
  z.repeat.copy(G.repeat);
  const k = new THREE.MeshStandardMaterial({
      color: C,
      roughness: 0.85,
      metalness: 0,
    }),
    B = new THREE.MeshStandardMaterial({
      map: G,
      roughnessMap: z,
      roughness: 0.85,
      metalness: 0,
    }),
    L = new THREE.MeshStandardMaterial({
      color: C,
      roughness: 0.85,
      metalness: 0,
    }),
    D = new THREE.Mesh(new THREE.PlaneGeometry(R, H), k);
  function A(t, e, n) {
    const a = new THREE.Mesh(new THREE.PlaneGeometry(R, x), B);
    (a.position.set(t, x / 2, e),
      (a.rotation.y = n),
      (a.receiveShadow = !0),
      v.add(a));
  }
  ((D.rotation.x = -Math.PI / 2),
    (D.receiveShadow = !0),
    v.add(D),
    A(0, -H / 2, 0),
    A(0, H / 2, Math.PI),
    A(-R / 2, 0, Math.PI / 2),
    A(R / 2, 0, -Math.PI / 2));
  const W = s.bandHeight;
  function O(t, e, n, a) {
    const o = new THREE.Mesh(new THREE.PlaneGeometry(a, W), L);
    (o.position.set(t + 0.02 * Math.sin(n), W / 2, e + 0.02 * Math.cos(n)),
      (o.rotation.y = n),
      (o.receiveShadow = !0),
      v.add(o));
  }
  (O(0, -H / 2 + 0.02, 0, R),
    O(0, H / 2 - 0.02, Math.PI, R),
    O(-R / 2 + 0.02, 0, Math.PI / 2, H),
    O(R / 2 - 0.02, 0, -Math.PI / 2, H));
  const V = new THREE.Mesh(new THREE.PlaneGeometry(400, 400), k);
  function X(t) {
    const e = 448,
      n = document.createElement("canvas");
    n.width = n.height = e;
    const a = n.getContext("2d"),
      o = (function () {
        const t = 5 + Math.floor(4 * Math.random()),
          e = [],
          n = 0.58 + 0.06 * (Math.random() - 0.5);
        for (let a = 0; a < t; a++) {
          const o = t > 1 ? a / (t - 1) : 0.5,
            i = Math.sin(o * Math.PI),
            s = 0.22 + 0.56 * o + 0.03 * (Math.random() - 0.5),
            r = n + 0.06 * (Math.random() - 0.5) - 0.07 * i,
            c = 0.07 + 0.05 * Math.random() + 0.09 * i;
          e.push({ x: s, y: r, r: c });
        }
        return e;
      })();
    function i(t, n) {
      (a.beginPath(),
        o.forEach((o) => {
          const i = 224 + (o.x * e - 224) * t,
            s = 224 + (o.y * e - 224) * t + (n || 0),
            r = o.r * e * t;
          (a.moveTo(i + r, s), a.arc(i, s, r, 0, 2 * Math.PI));
        }));
    }
    (i(1, 0.025 * e),
      (a.fillStyle = "#c3d8ea"),
      a.fill(),
      i(1.045, 0),
      (a.fillStyle = "#141414"),
      a.fill(),
      i(1, 0),
      (a.fillStyle = "#ffffff"),
      a.fill(),
      a.save(),
      i(1, 0),
      a.clip());
    const s = a.createLinearGradient(0, 0.4 * e, 0, 380.8);
    (s.addColorStop(0, "rgba(255,255,255,0)"),
      s.addColorStop(1, "rgba(190,215,235,0.55)"),
      (a.fillStyle = s),
      a.fillRect(0, 0, e, e),
      a.restore(),
      (function (t, e, n, a, o) {
        ((t.fillStyle = "#141414"),
          "closed" === o
            ? ((t.strokeStyle = "#141414"),
              (t.lineWidth = 0.013 * a),
              (t.lineCap = "round"),
              [-1, 1].forEach((o) => {
                (t.beginPath(),
                  t.arc(
                    e + o * a * 0.06,
                    n - 0.01 * a,
                    0.02 * a,
                    1.15 * Math.PI,
                    1.85 * Math.PI,
                  ),
                  t.stroke());
              }),
              (t.lineWidth = 0.012 * a),
              t.beginPath(),
              t.moveTo(e - 0.05 * a, n + 0.03 * a),
              t.quadraticCurveTo(e, n + 0.06 * a, e + 0.05 * a, n + 0.03 * a),
              t.stroke())
            : "giggle" === o
              ? ([-1, 1].forEach((o) => {
                  (t.save(),
                    t.translate(e + o * a * 0.06, n - 0.015 * a),
                    t.rotate(0.1 * o),
                    t.beginPath(),
                    t.ellipse(0, 0, 0.016 * a, 0.023 * a, 0, 0, 2 * Math.PI),
                    t.fill(),
                    t.restore());
                }),
                (t.strokeStyle = "#141414"),
                (t.lineWidth = 0.014 * a),
                (t.lineCap = "round"),
                t.beginPath(),
                t.arc(e, n + 0.01 * a, 0.045 * a, 0.1 * Math.PI, 0.9 * Math.PI),
                t.stroke())
              : ([-1, 1].forEach((o) => {
                  (t.save(),
                    t.translate(e + o * a * 0.06, n - 0.015 * a),
                    t.rotate(0.15 * o),
                    t.beginPath(),
                    t.ellipse(0, 0, 0.017 * a, 0.026 * a, 0, 0, 2 * Math.PI),
                    t.fill(),
                    t.restore());
                }),
                (t.strokeStyle = "#141414"),
                (t.lineWidth = 0.011 * a),
                (t.lineCap = "round"),
                t.beginPath(),
                t.moveTo(e - 0.045 * a, n + 0.02 * a),
                t.quadraticCurveTo(
                  e,
                  n + 0.045 * a,
                  e + 0.045 * a,
                  n + 0.02 * a,
                ),
                t.stroke()));
      })(a, 232.96, 0.56 * e, e, t));
    const r = new THREE.CanvasTexture(n);
    return ((r.encoding = THREE.sRGBEncoding), r);
  }
  function q(t, e) {
    (t.beginPath(), t.ellipse(0, 0, 0.46 * e, 0.32 * e, 0, 0, 2 * Math.PI));
  }
  function j(t, e, n) {
    const a = 384,
      o = document.createElement("canvas");
    o.width = o.height = a;
    const i = o.getContext("2d"),
      s = a * (0.12 + 0.07 * Math.random()),
      r = 192,
      c = 130.56 + 0.3 * s,
      l = (Math.random() - 0.5) * a * 0.03;
    ((i.strokeStyle = "#6bbf4a"),
      (i.lineWidth = a * (0.021 + 0.008 * Math.random())),
      (i.lineCap = "round"),
      i.beginPath(),
      i.moveTo(r, c + 0.6 * s),
      i.quadraticCurveTo(r + 0.5 * l, 299.52, r + l, 0.92 * a),
      i.stroke(),
      i.beginPath(),
      i.moveTo(r, 0.62 * a),
      i.quadraticCurveTo(
        r + a * (0.13 + 0.05 * Math.random()),
        0.58 * a,
        199.68,
        a * (0.72 + 0.04 * Math.random()),
      ),
      i.quadraticCurveTo(184.32, 253.44, r, 0.62 * a),
      (i.fillStyle = "#8fd35d"),
      i.fill(),
      (i.lineWidth = 0.012 * a),
      (i.strokeStyle = "#141414"),
      i.stroke());
    const d = Math.random() * Math.PI * 2,
      h = 1.3 * s;
    for (let e = 0; e < 6; e++) {
      const n = d + (e / 6) * Math.PI * 2;
      (i.save(),
        i.translate(r + Math.cos(n) * s * 1, c + Math.sin(n) * s * 1),
        i.rotate(n),
        q(i, h),
        (i.fillStyle = t),
        i.fill(),
        (i.lineWidth = 5.376),
        (i.strokeStyle = "#141414"),
        i.stroke(),
        i.restore());
    }
    (i.beginPath(),
      i.arc(r, c, s, 0, 2 * Math.PI),
      (i.fillStyle = e),
      i.fill(),
      (i.lineWidth = 5.376),
      (i.strokeStyle = "#141414"),
      i.stroke(),
      (function (t, e, n, a, o) {
        ((t.fillStyle = "#141414"),
          "wink" === o
            ? (t.beginPath(),
              t.arc(e - 0.32 * a, n - 0.12 * a, 0.07 * a, 0, 2 * Math.PI),
              t.fill(),
              (t.strokeStyle = "#141414"),
              (t.lineWidth = 0.06 * a),
              (t.lineCap = "round"),
              t.beginPath(),
              t.moveTo(e + 0.2 * a, n - 0.12 * a),
              t.lineTo(e + 0.42 * a, n - 0.12 * a),
              t.stroke(),
              t.beginPath(),
              t.moveTo(e - 0.26 * a, n + 0.08 * a),
              t.quadraticCurveTo(
                e + 0.05 * a,
                n + 0.32 * a,
                e + 0.32 * a,
                n + 0.02 * a,
              ),
              t.stroke())
            : "surprised" === o
              ? ([-1, 1].forEach((o) => {
                  (t.beginPath(),
                    t.arc(
                      e + o * a * 0.3,
                      n - 0.1 * a,
                      0.085 * a,
                      0,
                      2 * Math.PI,
                    ),
                    t.fill());
                }),
                t.beginPath(),
                t.arc(e, n + 0.24 * a, 0.1 * a, 0, 2 * Math.PI),
                t.fill())
              : "sleepy" === o
                ? ((t.strokeStyle = "#141414"),
                  (t.lineWidth = 0.07 * a),
                  (t.lineCap = "round"),
                  [-1, 1].forEach((o) => {
                    (t.beginPath(),
                      t.moveTo(e + o * a * 0.44, n - 0.1 * a),
                      t.lineTo(e + o * a * 0.18, n - 0.1 * a),
                      t.stroke());
                  }),
                  t.beginPath(),
                  t.arc(
                    e,
                    n + 0.05 * a,
                    0.15 * a,
                    0.15 * Math.PI,
                    0.85 * Math.PI,
                  ),
                  t.stroke())
                : "giggle" === o
                  ? ([-1, 1].forEach((o) => {
                      (t.beginPath(),
                        t.arc(
                          e + o * a * 0.32,
                          n - 0.1 * a,
                          0.065 * a,
                          0,
                          2 * Math.PI,
                        ),
                        t.fill());
                    }),
                    (t.strokeStyle = "#141414"),
                    (t.lineWidth = 0.08 * a),
                    (t.lineCap = "round"),
                    t.beginPath(),
                    t.arc(
                      e,
                      n + 0.02 * a,
                      0.3 * a,
                      0.1 * Math.PI,
                      0.9 * Math.PI,
                    ),
                    t.stroke())
                  : ([-1, 1].forEach((o) => {
                      (t.beginPath(),
                        t.arc(
                          e + o * a * 0.32,
                          n - 0.12 * a,
                          0.07 * a,
                          0,
                          2 * Math.PI,
                        ),
                        t.fill());
                    }),
                    (t.strokeStyle = "#141414"),
                    (t.lineWidth = 0.09 * a),
                    (t.lineCap = "round"),
                    t.beginPath(),
                    t.moveTo(e - 0.28 * a, n + 0.05 * a),
                    t.quadraticCurveTo(
                      e,
                      n + 0.35 * a,
                      e + 0.28 * a,
                      n + 0.05 * a,
                    ),
                    t.stroke()));
      })(i, r, c, s, n));
    const E = new THREE.CanvasTexture(o);
    return ((E.encoding = THREE.sRGBEncoding), E);
  }
  ((V.rotation.x = -Math.PI / 2), (V.position.y = -0.03), v.add(V));
  const F = [];
  ["smile", "closed", "giggle"].forEach((t) => {
    for (let e = 0; e < 3; e++) F.push(X(t));
  });
  const U = new THREE.Sprite(
    new THREE.SpriteMaterial({
      map: (function () {
        const t = 640,
          e = document.createElement("canvas");
        e.width = e.height = t;
        const n = e.getContext("2d"),
          a = 320,
          o = 320,
          i = 166.4;
        n.lineCap = "round";
        const s = [];
        for (let e = 0; e < 12; e++)
          s.push({
            ang: e * ((2 * Math.PI) / 12),
            len: t * (0.15 + 0.06 * Math.random()),
          });
        (s.forEach(({ ang: t, len: e }) => {
          const s = a + Math.cos(t) * (i + 6),
            r = o + Math.sin(t) * (i + 6),
            c = a + Math.cos(t) * (i + 6 + e),
            l = o + Math.sin(t) * (i + 6 + e);
          ((n.strokeStyle = "#141414"),
            (n.lineWidth = 17),
            n.beginPath(),
            n.moveTo(s, r),
            n.lineTo(c, l),
            n.stroke());
        }),
          s.forEach(({ ang: t, len: e }) => {
            const s = a + Math.cos(t) * (i + 6),
              r = o + Math.sin(t) * (i + 6),
              c = a + Math.cos(t) * (i + 6 + e),
              l = o + Math.sin(t) * (i + 6 + e);
            ((n.strokeStyle = "#eec257"),
              (n.lineWidth = 9),
              n.beginPath(),
              n.moveTo(s, r),
              n.lineTo(c, l),
              n.stroke());
          }),
          n.beginPath(),
          n.arc(a, o, 175.552, 0, 2 * Math.PI),
          (n.fillStyle = "#141414"),
          n.fill(),
          n.beginPath(),
          n.arc(a, o, i, 0, 2 * Math.PI),
          (function (t, e, n, a) {
            (t.save(), t.clip(), (t.fillStyle = n), t.fillRect(0, 0, e, e));
            for (let n = 0; n < 35; n++) {
              ((t.globalAlpha = 0.08 + 0.1 * Math.random()),
                (t.fillStyle = a[Math.floor(Math.random() * a.length)]));
              const n = Math.random() * e,
                o = Math.random() * e,
                i = 6 + 16 * Math.random();
              (t.beginPath(), t.arc(n, o, i, 0, 2 * Math.PI), t.fill());
            }
            ((t.globalAlpha = 1), t.restore());
          })(n, t, "#f2c94c", ["#eec257", "#f7d878", "#e2b23a"]),
          (n.fillStyle = "#141414"),
          [-1, 1].forEach((t) => {
            (n.beginPath(),
              n.arc(a + t * i * 0.34, 303.36, 12.48, 0, 2 * Math.PI),
              n.fill());
          }),
          (n.strokeStyle = "#141414"),
          (n.lineWidth = 0.09 * i),
          (n.lineCap = "round"),
          n.beginPath(),
          n.moveTo(263.424, 339.968),
          n.quadraticCurveTo(a, 403.2, 376.576, 339.968),
          n.stroke(),
          (n.fillStyle = "rgba(210,90,60,0.35)"),
          [-1, 1].forEach((t) => {
            (n.beginPath(),
              n.ellipse(
                a + t * i * 0.52,
                343.296,
                0.09 * i,
                9.984,
                0,
                0,
                2 * Math.PI,
              ),
              n.fill());
          }));
        const r = new THREE.CanvasTexture(e);
        return ((r.encoding = THREE.sRGBEncoding), r);
      })(),
      transparent: !0,
      depthWrite: !1,
    }),
  );
  (U.scale.set(30, 30, 1), U.position.set(-40, 50, -70), v.add(U));
  const Y = (function () {
    const t = new THREE.Group(),
      e = new THREE.MeshStandardMaterial({
        color: 9080729,
        metalness: 0.75,
        roughness: 0.25,
      }),
      n = new THREE.MeshStandardMaterial({
        color: 10216804,
        emissive: 10216804,
        emissiveIntensity: 1.1,
        roughness: 0.4,
      }),
      a = new THREE.Mesh(
        new THREE.SphereGeometry(1, 20, 12, 0, 2 * Math.PI, 0, Math.PI / 2),
        e,
      );
    t.add(a);
    const o = new THREE.Mesh(new THREE.CylinderGeometry(2.6, 1.6, 0.7, 24), e);
    t.add(o);
    const i = new THREE.Mesh(
      new THREE.SphereGeometry(1.6, 20, 10, 0, 2 * Math.PI, 0, Math.PI / 2),
      e,
    );
    ((i.rotation.x = Math.PI), (i.position.y = -0.35), t.add(i));
    const s = new THREE.Mesh(new THREE.TorusGeometry(2.6, 0.12, 10, 32), n);
    return (
      (s.rotation.x = Math.PI / 2),
      t.add(s),
      t.scale.set(7, 7, 7),
      { group: t, glowMat: n }
    );
  })();
  v.add(Y.group);
  let _ = Math.random() * Math.PI * 2,
    N = 45,
    K = 100,
    Z = 8 + 10 * Math.random();
  function $(t, e) {
    ((Z -= e),
      Z <= 0
        ? ((_ = Math.random() * Math.PI * 2),
          (N = 30 + 30 * Math.random()),
          (K = 85 + 30 * Math.random()),
          (Z = 10 + 14 * Math.random()),
          (Y.glowMat.emissiveIntensity = 3),
          f(220, 1400, 0.25, "square", 0.07, Y.group.position))
        : (Y.glowMat.emissiveIntensity = THREE.MathUtils.lerp(
            Y.glowMat.emissiveIntensity,
            1.1,
            Math.min(1, 2 * e),
          )));
    const n = 0.05 * t + _;
    (Y.group.position.set(
      Math.cos(n) * N,
      K + 2 * Math.sin(0.3 * t),
      Math.sin(n) * N,
    ),
      (Y.group.rotation.y = 0.15 * t));
  }
  const Q = ["smile", "wink", "surprised", "sleepy", "giggle"],
    J = [];
  // Una texture per combinazione colore/espressione (prima erano due,
  // identiche a vista): 60 texture invece di 120, metà memoria GPU.
  [
    { petal: "#f7a8c4", center: "#f2c94c" },
    { petal: "#ffb15c", center: "#f2c94c" },
    { petal: "#8ecae6", center: "#ffd166" },
    { petal: "#c9a6f2", center: "#ffe27a" },
    { petal: "#ff7a7a", center: "#ffe27a" },
    { petal: "#9be564", center: "#ffe27a" },
    { petal: "#ff5da2", center: "#fff2a8" },
    { petal: "#ffe27a", center: "#ff8a3d" },
    { petal: "#b088f9", center: "#ffffff" },
    { petal: "#ffffff", center: "#f2994a" },
    { petal: "#4dd9c0", center: "#ffe27a" },
    { petal: "#ff9f7a", center: "#c9a6f2" },
  ].forEach((t) => {
    Q.forEach((e) => {
      J.push(j(t.petal, t.center, e));
    });
  });
  const tt = [];
  function et(t, e, n, a) {
    const o = J[Math.floor(Math.random() * J.length)],
      i = new THREE.Sprite(
        new THREE.SpriteMaterial({ map: o, transparent: !0 }),
      );
    i.scale.set(n, n, 1);
    const s = 0.5 * n;
    return (
      i.position.set(t, s, e),
      (i.userData = {
        baseX: t,
        baseY: s,
        baseScale: n,
        isGround: !!a,
        speed: 0.12 + 0.14 * Math.random(),
        phase: Math.random() * Math.PI * 2,
        rotAmt: 0.06 + 0.06 * Math.random(),
        swayDist: 0.02 * n + 0.01 * Math.random(),
        state: "idle",
        hunted: !1,
        abductTimer: 0,
        respawnTimer: 0,
      }),
      v.add(i),
      tt.push(i),
      i
    );
  }
  for (let t = 0; t < s.flowerCount; t++) {
    const e = (t / s.flowerCount) * Math.PI * 2 + 0.5 * Math.random(),
      n = 38 + 55 * Math.random();
    et(Math.cos(e) * n, Math.sin(e) * n, 28 + 24 * Math.random(), !1);
  }
  // Posizione del silo di acciaio, al centro della stanza. Unica fonte di
  // verità: usata qui per il no-spawn dei fiori, più avanti per costruire
  // il silo (buildSteelSilo) e in ze() per l'evitamento ostacoli durante
  // il movimento del visitatore.
  const pt = [{ x: 0, z: 0 }];
  function at(t) {
    let e,
      n,
      a = 0;
    do {
      ((e = (Math.random() - 0.5) * (R - 2.5)),
        (n = (Math.random() - 0.5) * (H - 2.5)),
        a++);
    } while (a < 12 && pt.some((t) => Math.hypot(e - t.x, n - t.z) < 1.6));
    (t.position.set(e, t.userData.baseY, n), (t.userData.baseX = e));
  }
  for (let t = 0; t < 24; t++) {
    at(et(0, 0, 0.55 + 0.35 * Math.random(), !0));
  }
  const ot = [],
    it = new THREE.MeshStandardMaterial({
      color: 3816e3,
      metalness: 0.6,
      roughness: 0.4,
    }),
    st = new THREE.MeshStandardMaterial({
      color: 10133672,
      metalness: 0.7,
      roughness: 0.35,
    }),
    rt = new THREE.MeshStandardMaterial({
      color: 10216804,
      transparent: !0,
      opacity: 0.42,
      roughness: 0.15,
    }),
    ct = new THREE.MeshStandardMaterial({ color: 1315860, roughness: 0.7 }),
    lt = new THREE.MeshStandardMaterial({
      color: 13625599,
      transparent: !0,
      opacity: 0.22,
      roughness: 0.05,
      metalness: 0.1,
      side: THREE.DoubleSide,
    }),
    dt = new THREE.MeshStandardMaterial({
      color: 13949406,
      metalness: 0.7,
      roughness: 0.3,
    }),
    ht = new THREE.MeshStandardMaterial({
      color: 10216804,
      emissive: 10216804,
      emissiveIntensity: 0.7,
      roughness: 0.4,
    });
  function Et({
    x: t,
    y0: e,
    z: n,
    radius: a,
    height: o,
    flowerScale: i,
    isProtected: s,
    withFlower: r = !0,
  }) {
    const c = new THREE.Mesh(new THREE.CylinderGeometry(a, a, o, 20), dt);
    (c.position.set(t, e + o / 2, n), (c.castShadow = !0), v.add(c));
    const l = new THREE.Mesh(
      new THREE.SphereGeometry(a, 16, 10, 0, 2 * Math.PI, 0, Math.PI / 2),
      dt,
    );
    (l.position.set(t, e + o, n), v.add(l));
    const d = 0.4 * o,
      h = e + 0.52 * o,
      E = new THREE.Mesh(
        new THREE.CylinderGeometry(a + 0.01, a + 0.01, d, 20, 1, !0),
        lt,
      );
    (E.position.set(t, h, n), v.add(E));
    const p = new THREE.Mesh(
      new THREE.TorusGeometry(a + 0.02, 0.03 * a, 8, 24),
      ht,
    );
    ((p.rotation.x = Math.PI / 2), p.position.set(t, h - d / 2, n), v.add(p));
    const m = p.clone();
    (m.position.set(t, h + d / 2, n), v.add(m));
    const u = new THREE.Mesh(
      new THREE.CylinderGeometry(a + 0.05, a + 0.14, 0.03 * o, 20),
      it,
    );
    if (
      (u.position.set(t, e + 0.015 * o, n), (u.castShadow = !0), v.add(u), !r)
    )
      return null;
    const M = et(t, n, i, !1);
    return (
      M.position.set(t, h, n),
      (M.userData.baseY = h),
      (M.userData.protected = !!s),
      M
    );
  }
  // Contenuto fisso mostrato sui piccoli schermi dei robot impollinatori
  // (stringhe vuote = riga di spaziatura, non testo). Nessun contenuto
  // casuale o di debug.
  const SCREEN_LINES = [
    "Utopia v4.1",
    "",
    "Loading...",
    "",
    "Flowers.exe started",
    "",
    "reality overwritten",
  ];
  const SCREEN_REVEAL_INTERVAL = 0.5, // secondi tra la comparsa di una riga e la successiva
    SCREEN_HOLD_TIME = 3.5, // pausa a testo completo prima di ricominciare il loop
    SCREEN_CURSOR_BLINK = 0.5; // cadenza del blink del cursore
  function drawTerminalScreen(ctx, w, h, fontSize, lineHeight, gapHeight, topPad, visibleLines, cursorOn) {
    ((ctx.fillStyle = "#06130a"), ctx.fillRect(0, 0, w, h));
    ((ctx.fillStyle = "#6dfa9c"),
      (ctx.font = `700 ${fontSize}px monospace`),
      (ctx.textBaseline = "top"));
    let y = topPad,
      lastY = y,
      lastLine = "";
    for (let i = 0; i < visibleLines && i < SCREEN_LINES.length; i++) {
      const line = SCREEN_LINES[i];
      (line && ctx.fillText(line, 16, y), (lastY = y), (lastLine = line));
      y += line ? lineHeight : gapHeight;
    }
    if (cursorOn && visibleLines > 0) {
      const cw = 0.55 * fontSize;
      ctx.fillRect(16 + ctx.measureText(lastLine).width + 6, lastY, cw, fontSize);
    }
    ((ctx.globalAlpha = 0.08), (ctx.fillStyle = "#000"));
    for (let a = 0; a < h; a += 4) ctx.fillRect(0, a, w, 2);
    ctx.globalAlpha = 1;
  }
  // Un unico silo di acciaio al centro della stanza, alto l'80%
  // dell'altezza delle pareti (x = altezza stanza).
  const SILO_RADIUS = 1.1,
    SILO_HEIGHT = 0.8 * x,
    steelMat = new THREE.MeshStandardMaterial({
      color: 0x9aa4ad,
      metalness: 0.85,
      roughness: 0.28,
    });
  function buildSteelSilo(x0, z0) {
    const bodyHeight = SILO_HEIGHT * 0.86, // il resto è la cupola conica in cima
      capHeight = SILO_HEIGHT - bodyHeight,
      body = new THREE.Mesh(
        new THREE.CylinderGeometry(SILO_RADIUS, SILO_RADIUS, bodyHeight, 24),
        steelMat,
      );
    (body.position.set(x0, bodyHeight / 2, z0), (body.castShadow = !0), v.add(body));
    const cap = new THREE.Mesh(
      new THREE.ConeGeometry(SILO_RADIUS, capHeight, 24),
      steelMat,
    );
    (cap.position.set(x0, bodyHeight + capHeight / 2, z0),
      (cap.castShadow = !0),
      v.add(cap));
    // Due fasce orizzontali (giunture), in coerenza con lo stile a bande
    // già usato per i vasi delle piante (Et) — stessa "grammatica" visiva.
    [0.32, 0.66].forEach((f) => {
      const band = new THREE.Mesh(
        new THREE.TorusGeometry(SILO_RADIUS + 0.02, 0.035, 8, 24),
        ht,
      );
      ((band.rotation.x = Math.PI / 2), band.position.set(x0, bodyHeight * f, z0), v.add(band));
    });
    const base = new THREE.Mesh(
      new THREE.CylinderGeometry(SILO_RADIUS + 0.06, SILO_RADIUS + 0.18, 0.08, 24),
      steelMat,
    );
    (base.position.set(x0, 0.04, z0), (base.castShadow = !0), v.add(base));
  }
  pt.forEach((t) => buildSteelSilo(t.x, t.z));
  const wt = (function () {
    const t = 128,
      e = document.createElement("canvas");
    ((e.width = 32), (e.height = t));
    const n = e.getContext("2d");
    ((n.fillStyle = "rgba(80,200,70,0.55)"), n.fillRect(0, 0, 32, t));
    for (let t = 0; t < 4; t++) {
      const e = 32 * t,
        a = n.createLinearGradient(0, e, 0, e + 32);
      (a.addColorStop(0, "rgba(150,255,110,0.25)"),
        a.addColorStop(0.5, "rgba(170,255,120,1)"),
        a.addColorStop(1, "rgba(150,255,110,0.25)"),
        (n.fillStyle = a),
        n.fillRect(0, e, 32, 32));
    }
    const a = new THREE.CanvasTexture(e);
    return ((a.wrapS = a.wrapT = THREE.RepeatWrapping), a.repeat.set(1, 3), a);
  })();
  ot.push({
    update: (t, e) => {
      wt.offset.y -= 1.4 * (e || 0.016);
    },
  });
  const gt = (function () {
    const t = 64,
      e = document.createElement("canvas");
    e.width = e.height = t;
    const n = e.getContext("2d"),
      a = n.createRadialGradient(32, 32, 0, 32, 32, 32);
    (a.addColorStop(0, "rgba(140,255,110,1)"),
      a.addColorStop(0.6, "rgba(120,240,90,0.9)"),
      a.addColorStop(1, "rgba(120,240,90,0)"),
      (n.fillStyle = a),
      n.beginPath(),
      n.arc(32, 32, 32, 0, 2 * Math.PI),
      n.fill());
    const o = new THREE.CanvasTexture(e);
    return ((o.encoding = THREE.sRGBEncoding), o);
  })();
  const Tt = (function () {
    const t = document.createElement("canvas");
    t.width = t.height = 256;
    const e = t.getContext("2d");
    for (let t = 0; t < 16; t++) {
      const t = 256 * Math.random(),
        n = 256 * Math.random(),
        a = 16 + 26 * Math.random(),
        o = e.createRadialGradient(t, n, 0, t, n, a);
      (o.addColorStop(0, "rgba(110,235,90,0.85)"),
        o.addColorStop(0.7, "rgba(90,210,80,0.5)"),
        o.addColorStop(1, "rgba(90,210,80,0)"),
        (e.fillStyle = o),
        e.beginPath(),
        e.arc(t, n, a, 0, 2 * Math.PI),
        e.fill());
    }
    const n = new THREE.CanvasTexture(t);
    return ((n.encoding = THREE.sRGBEncoding), n);
  })();
  function yt(t, e, n) {
    const a = new THREE.Vector3(
      (t.x + e.x) / 2,
      0.4 * Math.min(t.y, e.y),
      (t.z + e.z) / 2,
    );
    a.y = Math.max(0.02, a.y - (n || 0.3));
    const o = new THREE.QuadraticBezierCurve3(t, a, e),
      i = new THREE.Mesh(new THREE.TubeGeometry(o, 12, 0.03, 6, !1), ct);
    v.add(i);
  }
  function Rt(t, e, n) {
    const a = new THREE.Group(),
      o = new THREE.Mesh(new THREE.BoxGeometry(0.85, 0.7, 0.7), it);
    ((o.position.y = 0.65), (o.castShadow = !0), a.add(o));
    const i = new THREE.Mesh(new THREE.BoxGeometry(0.5, 0.3, 0.5), it);
    ((i.position.y = 0.15), a.add(i));
    const s = (function () {
        const canvas = document.createElement("canvas");
        canvas.width = canvas.height = 256;
        const ctx = canvas.getContext("2d"),
          tex = new THREE.CanvasTexture(canvas);
        tex.encoding = THREE.sRGBEncoding;
        const fontSize = 16,
          lineHeight = 1.3 * fontSize,
          gapHeight = 0.6 * fontSize,
          topPad = 1.2 * lineHeight;
        let revealed = 0,
          revealTimer = SCREEN_REVEAL_INTERVAL * Math.random(),
          holding = !1,
          holdTimer = 0,
          cursorOn = !0,
          cursorTimer = SCREEN_CURSOR_BLINK * Math.random();
        function redraw() {
          (drawTerminalScreen(
            ctx,
            256,
            256,
            fontSize,
            lineHeight,
            gapHeight,
            topPad,
            revealed,
            cursorOn,
          ),
            (tex.needsUpdate = !0));
        }
        function tick(dt) {
          dt = dt || 0.016;
          let needsRedraw = !1;
          if (revealed < SCREEN_LINES.length) {
            revealTimer += dt;
            if (revealTimer >= SCREEN_REVEAL_INTERVAL) {
              ((revealTimer = 0), revealed++, (needsRedraw = !0));
            }
          } else if (!holding) {
            ((holding = !0), (holdTimer = SCREEN_HOLD_TIME));
          } else {
            holdTimer -= dt;
            if (holdTimer <= 0) {
              ((revealed = 0), (holding = !1), (needsRedraw = !0));
            }
          }
          cursorTimer += dt;
          if (cursorTimer >= SCREEN_CURSOR_BLINK) {
            ((cursorTimer = 0), (cursorOn = !cursorOn), (needsRedraw = !0));
          }
          needsRedraw && redraw();
        }
        return (redraw(), { tex, tick });
      })(),
      r = new THREE.MeshStandardMaterial({
        map: s.tex,
        emissive: 3124831,
        emissiveIntensity: 0.35,
        roughness: 0.3,
      }),
      c = new THREE.Mesh(new THREE.PlaneGeometry(0.66, 0.5), r);
    (c.position.set(0, 0.66, 0.36),
      a.add(c),
      a.position.set(t, 0, e),
      (a.rotation.y = n),
      v.add(a));
    (ot.push({
      update: (e, n) => {
        ((r.emissiveIntensity = 0.3 + 0.1 * Math.sin(7 * e + 3 * t)),
          s.tick(n));
      },
    }),
      yt(
        new THREE.Vector3(t, 0.5, e),
        new THREE.Vector3(t + 1.3 * Math.sin(n), 0.02, e + 1.3 * Math.cos(n)),
        0.3,
      ),
      (function (t, e) {
        const n = new THREE.Vector3(
            (t.x + e.x) / 2,
            Math.max(t.y, e.y) + 0.5,
            (t.z + e.z) / 2,
          ),
          a = new THREE.QuadraticBezierCurve3(t, n, e),
          o = new THREE.Mesh(new THREE.TubeGeometry(a, 14, 0.07, 8, !1), rt);
        v.add(o);
        const i = new THREE.Mesh(
          new THREE.TubeGeometry(a, 14, 0.058, 8, !1),
          new THREE.MeshBasicMaterial({
            map: wt,
            transparent: !0,
            blending: THREE.AdditiveBlending,
            depthWrite: !1,
            side: THREE.DoubleSide,
          }),
        );
        v.add(i);
        const s = new THREE.Mesh(
          new THREE.CylinderGeometry(0.13, 0.15, 0.06, 10),
          it,
        );
        (s.position.set(e.x, 0.03, e.z), v.add(s));
        const r = new THREE.Mesh(new THREE.ConeGeometry(0.045, 0.16, 6), st);
        (r.position.set(e.x, -0.02, e.z), (r.rotation.x = Math.PI), v.add(r));
      })(
        new THREE.Vector3(t, 1, e),
        new THREE.Vector3(t - 1.6 * Math.sin(n), 0.02, e - 1.6 * Math.cos(n)),
      ));
  }
  // Altezza delle torri-irrigatore, ridotta del 50% rispetto all'originale
  // (era 2.1). La distanza di caduta delle gocce è scalata in proporzione,
  // così continuano a cadere dall'ugello fino quasi a terra.
  const SPRINKLER_HEIGHT = 1.05,
    SPRINKLER_FALL = 1.97 * (SPRINKLER_HEIGHT / 2.1);
  function Ht(t, e) {
    const n = new THREE.Group(),
      a = new THREE.Mesh(
        new THREE.CylinderGeometry(0.05, 0.06, SPRINKLER_HEIGHT, 8),
        st,
      );
    ((a.position.y = SPRINKLER_HEIGHT / 2), n.add(a));
    const o = new THREE.Group(),
      i = new THREE.Mesh(new THREE.BoxGeometry(1.1, 0.06, 0.06), st);
    ((i.position.x = 0.55),
      o.add(i),
      [0.25, 0.6, 0.95].forEach((n) => {
        const a = new THREE.Mesh(new THREE.ConeGeometry(0.045, 0.12, 6), it);
        (a.position.set(n, -0.08, 0), (a.rotation.x = Math.PI), o.add(a));
        for (let t = 0; t < 4; t++) {
          const t = new THREE.Sprite(
            new THREE.SpriteMaterial({
              map: gt,
              transparent: !0,
              depthWrite: !1,
            }),
          );
          t.scale.set(0.11, 0.11, 1);
          const e = Math.random(),
            a = 0.6 + 0.3 * Math.random();
          let i = e;
          (o.add(t),
            ot.push({
              update: (e, o) => {
                i += (o || 0.016) * a * jt;
                const s = ((i % 1) + 1) % 1;
                (t.position.set(n, -0.08 - SPRINKLER_FALL * s, 0),
                  (t.material.opacity = 1 - s));
              },
            }));
        }
        const i = new THREE.Mesh(
          new THREE.RingGeometry(Math.max(0.05, n - 0.16), n + 0.16, 28),
          new THREE.MeshBasicMaterial({
            map: Tt,
            transparent: !0,
            opacity: 0,
            depthWrite: !1,
            side: THREE.DoubleSide,
          }),
        );
        ((i.rotation.x = -Math.PI / 2), i.position.set(t, 0.014, e), v.add(i));
        const s = 10 * Math.random();
        let r = !1;
        ot.push({
          update: (t) => {
            const e = Math.min(1, t / 8);
            ((i.material.opacity = e * (0.45 + 0.15 * Math.sin(0.5 * t + s))),
              e >= 1 && !r && ((r = !0), w(0.25, 0.045, 3e3, i.position)));
          },
        });
      }),
      (o.position.y = SPRINKLER_HEIGHT),
      n.add(o),
      n.position.set(t, 0, e),
      v.add(n));
    let s = 0;
    ot.push({
      update: (e, n) => {
        ((s += (n || 0.016) * jt), (o.rotation.y = 0.7 * s + t));
      },
    });
  }
  function xt(t, e) {
    const n = 43758.5453 * Math.sin(12.9898 * t + 78.233 * e);
    return (n - Math.floor(n)) * Math.PI * 2;
  }
  function St(t) {
    return (t = Math.max(0, Math.min(1, t))) * t * (3 - 2 * t);
  }
  function vt(t, e) {
    return St(Math.max(0, Math.min(1, (t - e) / (1 - e))));
  }
  // Ampiezza massima (radianti) di ciascun giunto del braccio robotico
  // piantatore. Le tre rotazioni condividono lo stesso segno: spalla,
  // gomito e polso curvano tutti nello stesso verso, come un vero braccio
  // che si piega in avanti e verso il basso per raggiungere il terreno
  // (anziché il gomito che "disfa" la curva della spalla, come accadeva
  // in precedenza). Gerarchia: a(radice) > i(torretta, yaw) >
  // s(spalla, pitch) > c(gomito, pitch) > d(polso, pitch) > E(pinza).
  const SHOULDER_BEND = 0.95,
    ELBOW_BEND = 0.55,
    WRIST_BEND = 0.22;
  function It(t, e, n) {
    const a = new THREE.Group(),
      o = new THREE.Mesh(new THREE.CylinderGeometry(0.28, 0.34, 0.25, 12), it);
    ((o.position.y = 0.12), a.add(o));
    const i = new THREE.Group();
    ((i.position.y = 0.25), a.add(i));
    const s = new THREE.Group();
    i.add(s);
    const r = new THREE.Mesh(new THREE.BoxGeometry(0.13, 1, 0.13), st);
    ((r.position.y = 0.5), s.add(r));
    const c = new THREE.Group();
    ((c.position.y = 1), s.add(c));
    const l = new THREE.Mesh(new THREE.BoxGeometry(0.1, 0.75, 0.1), st);
    ((l.position.y = 0.375), c.add(l));
    const d = new THREE.Group();
    ((d.position.y = 0.75), c.add(d));
    const h = new THREE.Mesh(
      new THREE.CylinderGeometry(0.07, 0.08, 0.28, 8),
      st,
    );
    ((h.position.y = 0.14), d.add(h));
    const E = new THREE.Group();
    ((E.position.y = 0.28), d.add(E));
    const p = new THREE.Mesh(new THREE.ConeGeometry(0.045, 0.2, 5), it);
    (p.position.set(-0.05, 0.1, 0), (p.rotation.z = 0.35), E.add(p));
    const m = new THREE.Mesh(new THREE.ConeGeometry(0.045, 0.2, 5), it);
    (m.position.set(0.05, 0.1, 0),
      (m.rotation.z = -0.35),
      E.add(m),
      a.position.set(t, 0, e),
      (a.rotation.y = n),
      v.add(a));
    const u = et(t, e, 0.85, !0);
    u.scale.set(0, 0, 1);
    let M = -1;
    const w = 4.6,
      g = 1.7 * t + 0.6 * e;
    let T = "rest",
      y = g;
    (ot.push({
      update: (o, r) => {
        y += (r || 0.016) * jt;
        const l = y,
          h = Math.floor(l / w),
          E = (((l % w) + w) % w) / w,
          R = xt(h, g);
        let H, x, S, v, I, P;
        if (E < 0.3) {
          P = "reach";
          const t = E / 0.3;
          ((H = St(t) + 0.06 * Math.sin(t * Math.PI) * (1 - t)),
            (x = vt(t, 0.18)),
            (S = vt(t, 0.34)),
            (v = R * St(t)),
            (I = 0));
        } else if (E < 0.45) {
          P = "plant";
          const a =
            0.02 *
            Math.sin(((E - 0.3) / 0.15) * Math.PI * 4) *
            (1 - (E - 0.3) / 0.15);
          if (
            ((H = 1 + a),
            (x = 1 + 0.7 * a),
            (S = 1),
            (v = R),
            (I = 0.3 * Math.sin(((E - 0.3) / 0.15) * Math.PI)),
            M !== h)
          ) {
            M = h;
            const a = t + 2.2 * Math.sin(n + R),
              o = e + 2.2 * Math.cos(n + R);
            (u.position.set(a, u.userData.baseY, o),
              (u.userData.baseX = a),
              (u.userData.state = "growing"),
              (u.userData.growTimer = 0),
              f(880, 1320, 0.5, "sine", 0.08, (b = u.position)),
              setTimeout(() => f(1318, 1760, 0.4, "sine", 0.05, b), 80),
              (u.material.map = J[Math.floor(Math.random() * J.length)]));
          }
        } else if (E < 0.75) {
          P = "rise";
          const t = (E - 0.45) / 0.3;
          ((S = 1 - St(t)),
            (x = 1 - vt(t, 0.18)),
            (H = 1 - vt(t, 0.34)),
            (v = R),
            (I = 0));
        } else {
          P = "rest";
          const t = 0.04 * Math.sin(0.8 * y + g);
          ((H = t),
            (x = 0.6 * t),
            (S = 0),
            (I = 0),
            (v = THREE.MathUtils.lerp(R, xt(h + 1, g), (E - 0.75) / 0.25)));
        }
        var b;
        (P === T ||
          ("reach" !== P && "rise" !== P) ||
          (function (t) {
            f(180, 260, 0.18, "triangle", 0.04, t);
          })(a.position),
          (T = P),
          (s.rotation.z = -SHOULDER_BEND * H),
          (c.rotation.z = -ELBOW_BEND * x),
          (d.rotation.z = -WRIST_BEND * S),
          (i.rotation.y = v),
          (p.rotation.z = 0.35 - I),
          (m.rotation.z = -0.35 + I));
      },
    }),
      yt(
        new THREE.Vector3(t, 0.15, e),
        new THREE.Vector3(t + 1.3, 0.02, e + 0.5),
        0.25,
      ));
  }
  function Pt(t, e, n) {
    (Et({
      x: t,
      y0: 0,
      z: e,
      radius: 0.42,
      height: 1.55,
      flowerScale: 1.05,
      isProtected: !0,
    }),
      n && yt(new THREE.Vector3(t, 0.5, e), n, 0.4));
  }
  (Rt(-12.5, -6, 0.45 * Math.PI),
    Rt(12, 4, -Math.PI / 2),
    Rt(-11, 10, Math.PI / 3),
    Rt(11.5, -10.5, 0.6 * -Math.PI),
    Rt(-5.5, -13, 0.15 * Math.PI),
    Rt(6, 13, 0.9 * Math.PI),
    Ht(-6.5, -10.5),
    Ht(7, 10),
    Ht(-10, 3),
    Ht(10.5, -3.5),
    It(6, -9.5, -0.6),
    It(-5, 5, 2.4),
    It(12.5, 12, -2),
    It(-12, -12, 0.8),
    It(4.5, 0.5, 1.5),
    Pt(-10.3, -4.2, new THREE.Vector3(-12.5, 0.5, -6)),
    Pt(10, 1.8, new THREE.Vector3(12, 0.5, 4)));
  const bt = [];
  for (let t = 0; t < 9; t++) {
    const t = 16 + 12 * Math.random(),
      e = 0.72 * t,
      n = new THREE.Sprite(
        new THREE.SpriteMaterial({
          map: F[Math.floor(Math.random() * F.length)],
          transparent: !0,
          depthWrite: !1,
        }),
      );
    n.scale.set(t, e, 1);
    let a,
      o,
      i = 0;
    const s = 22;
    do {
      ((a = 80 * (Math.random() - 0.5)), (o = 80 * (Math.random() - 0.5)), i++);
    } while (
      i < 20 &&
      bt.some((t) => Math.hypot(a - t.position.x, o - t.position.z) < s)
    );
    (n.position.set(a, 24 + 14 * Math.random(), o),
      (n.userData.speed = 0.25 + 0.4 * Math.random()),
      v.add(n),
      bt.push(n));
  }
  const Ct = (function () {
      const t = 256,
        e = document.createElement("canvas");
      e.width = e.height = t;
      const n = e.getContext("2d");
      for (let e = 0; e < 6; e++) {
        const e = 51.2 + Math.random() * t * 0.6,
          a = 89.6 + Math.random() * t * 0.3,
          o = t * (0.14 + 0.12 * Math.random()),
          i = n.createRadialGradient(e, a, 0, e, a, o);
        (i.addColorStop(0, "rgba(20,40,15,0.55)"),
          i.addColorStop(1, "rgba(20,40,15,0)"),
          (n.fillStyle = i),
          n.beginPath(),
          n.arc(e, a, o, 0, 2 * Math.PI),
          n.fill());
      }
      const a = new THREE.CanvasTexture(e);
      return ((a.encoding = THREE.sRGBEncoding), a);
    })(),
    Gt = bt.map((t) => {
      const e = new THREE.Mesh(
        new THREE.PlaneGeometry(0.9 * t.scale.x, 0.9 * t.scale.y),
        new THREE.MeshBasicMaterial({
          map: Ct,
          transparent: !0,
          opacity: 0.3,
          depthWrite: !1,
        }),
      );
      return (
        (e.rotation.x = -Math.PI / 2),
        e.position.set(t.position.x, 0.018, t.position.z),
        v.add(e),
        { mesh: e, cloud: t }
      );
    });
  const zt = new THREE.HemisphereLight(12575743, 10474616, n.ambientIntensity);
  v.add(zt);
  const kt = new THREE.DirectionalLight(16775404, n.sunIntensity);
  function Bt(t) {
    const e = 400,
      n = document.createElement("canvas");
    n.width = n.height = e;
    const a = n.getContext("2d");
    (a.beginPath(),
      a.arc(200, 200, 168, 0, 2 * Math.PI),
      (a.fillStyle = t),
      a.fill(),
      (a.lineWidth = 8),
      (a.strokeStyle = "#141414"),
      a.stroke(),
      (a.fillStyle = "rgba(150,165,185,0.4)"));
    for (let t = 0; t < 6; t++) {
      const t = Math.random() * Math.PI * 2,
        n = Math.random() * e * 0.26,
        o = 200 + Math.cos(t) * n,
        i = 200 + Math.sin(t) * n,
        s = e * (0.03 + 0.05 * Math.random());
      (a.beginPath(), a.arc(o, i, s, 0, 2 * Math.PI), a.fill());
    }
    const o = new THREE.CanvasTexture(n);
    return ((o.encoding = THREE.sRGBEncoding), o);
  }
  ((kt.castShadow = !0),
    kt.shadow.mapSize.set(1024, 1024),
    (kt.shadow.camera.left = -14),
    (kt.shadow.camera.right = 14),
    (kt.shadow.camera.top = 14),
    (kt.shadow.camera.bottom = -14),
    (kt.shadow.camera.near = 1),
    (kt.shadow.camera.far = 100),
    (kt.shadow.bias = -0.0015),
    v.add(kt),
    v.add(kt.target));
  const Lt = new THREE.Sprite(
    new THREE.SpriteMaterial({
      map: Bt("#e8eef7"),
      transparent: !0,
      depthWrite: !1,
      opacity: 0,
    }),
  );
  (Lt.scale.set(15, 15, 1), v.add(Lt));
  const Dt = new THREE.Sprite(
    new THREE.SpriteMaterial({
      map: Bt("#cfe0ee"),
      transparent: !0,
      depthWrite: !1,
      opacity: 0,
    }),
  );
  (Dt.scale.set(9, 9, 1), v.add(Dt));
  const At = new THREE.DirectionalLight(11192575, 0);
  (v.add(At), v.add(At.target));
  const Wt = new THREE.DirectionalLight(9349344, 0);
  (v.add(Wt), v.add(Wt.target));
  const Ot = new THREE.Color(8307954),
    Vt = new THREE.Color(725040),
    Xt = new THREE.Color(3820149),
    qt = new THREE.Color();
  let jt = 1,
    Ft = 1;
  function Ut(t, e, n) {
    const a = 2 * n,
      o = Math.PI * e;
    let i = (((t % 1) + 1) % 1) * (2 * a + 2 * o);
    if (i < a) return { x: e, z: -n + i };
    if (((i -= a), i < o)) {
      const t = i / e;
      return { x: e * Math.cos(t), z: n + e * Math.sin(t) };
    }
    if (((i -= o), i < a)) return { x: -e, z: n - i };
    i -= a;
    const s = Math.PI + i / e;
    return { x: e * Math.cos(s), z: -n + e * Math.sin(s) };
  }
  function Yt(t) {
    const e = new THREE.Group(),
      a = new THREE.Mesh(
        new THREE.SphereGeometry(0.55, 20, 12),
        new THREE.MeshStandardMaterial({
          color: 3816770,
          metalness: 0.7,
          roughness: 0.25,
        }),
      );
    (a.scale.set(1, 0.28, 1), e.add(a));
    const o = new THREE.Mesh(
      new THREE.SphereGeometry(0.24, 16, 10, 0, 2 * Math.PI, 0, Math.PI / 2),
      new THREE.MeshStandardMaterial({
        color: 10216804,
        transparent: !0,
        opacity: 0.55,
        roughness: 0.15,
        emissive: 4880938,
        emissiveIntensity: 0.3,
      }),
    );
    ((o.position.y = 0.06), e.add(o));
    const i = new THREE.Mesh(
      new THREE.TorusGeometry(0.5, 0.045, 8, 24),
      new THREE.MeshStandardMaterial({
        color: 16773840,
        emissive: 16773840,
        emissiveIntensity: 0.8,
        roughness: 0.4,
      }),
    );
    ((i.rotation.x = Math.PI / 2), (i.position.y = -0.02), e.add(i));
    const s = new THREE.Mesh(
      new THREE.CircleGeometry(0.18, 20),
      new THREE.MeshStandardMaterial({
        color: 16774886,
        emissive: 16773840,
        emissiveIntensity: 0.55,
        roughness: 0.3,
      }),
    );
    ((s.rotation.x = Math.PI / 2), (s.position.y = -0.15), e.add(s));
    const r = new THREE.SpotLight(
      16773856,
      n.droneIntensity,
      9,
      Math.PI / 6,
      0.45,
      1.6,
    );
    r.position.set(0, -0.15, 0);
    const c = new THREE.Object3D();
    (c.position.set(0, -3, 0), e.add(c), (r.target = c), e.add(r));
    const l = new THREE.ConeGeometry(0.4, 1, 12, 1, !0);
    l.translate(0, -0.5, 0);
    const d = new THREE.Mesh(
      l,
      new THREE.MeshBasicMaterial({
        color: 10216804,
        transparent: !0,
        opacity: 0,
        depthWrite: !1,
        side: THREE.DoubleSide,
      }),
    );
    return (
      e.add(d),
      (e.userData = {
        spot: r,
        beamMesh: d,
        state: "patrol",
        R: 4.2 + 0.45 * t,
        halfLen: 7.5,
        height: 6.4 + 0.15 * t,
        phase: Math.random(),
        speed: 0.03 + 0.012 * Math.random(),
        cooldown: 4 + 6 * Math.random(),
        inspectTimer: 0,
        targetIndex: 0,
        huntTarget: null,
        huntTimer: 0,
        captureTimer: 0,
      }),
      e
    );
  }
  const _t = [];
  for (let t = 0; t < i.count; t++) {
    const e = Yt(t);
    (v.add(e), _t.push(e));
  }
  function Nt(t, e) {
    const n = t.userData.beamMesh,
      a = Math.max(0.2, t.position.y);
    (n.scale.set(a, a, a),
      (n.material.opacity = THREE.MathUtils.lerp(
        n.material.opacity,
        0.55 * e,
        0.15,
      )));
  }
  const Kt = new THREE.Vector3();
  function Zt(t, e) {
    _t.forEach((a) => {
      const o = a.userData;
      if ("patrol" === o.state) {
        const i = e * o.speed + o.phase,
          s = Ut(i, o.R, o.halfLen);
        a.position.lerp(Kt.set(s.x, o.height, s.z), Math.min(1, 3 * t));
        const r = Ut(i + 0.001, o.R, o.halfLen);
        if (
          ((a.rotation.y = Math.atan2(r.x - s.x, r.z - s.z)),
          (a.rotation.z = 0.03 * Math.sin(0.6 * e + 10 * o.phase)),
          (o.spot.intensity = n.droneIntensity * Ft),
          Nt(a, 0),
          (o.cooldown -= t),
          o.cooldown <= 0)
        ) {
          const t = tt.filter(
            (t) =>
              t.userData.isGround &&
              "idle" === t.userData.state &&
              !t.userData.protected,
          );
          if (Math.random() < 0.5 && t.length) {
            const e = t[Math.floor(Math.random() * t.length)];
            ((e.userData.state = "hunted"),
              (o.state = "hunt"),
              (o.huntTarget = e),
              (o.huntTimer = 0),
              (o.captureTimer = 0),
              w(0.6, 0.05, 900, a.position));
          } else
            ((o.state = "inspect"),
              (o.targetIndex = Math.floor(Math.random() * l.length)),
              (o.inspectTimer = 3.5 + 1.5 * Math.random()));
        }
      } else if ("inspect" === o.state) {
        const e = (function (t) {
          return 0 === t.ry
            ? { x: t.x, z: t.z + 1.5 }
            : t.ry === Math.PI / 2
              ? { x: t.x + 1.5, z: t.z }
              : { x: t.x - 1.5, z: t.z };
        })(Qt(o.targetIndex, l.length));
        (a.position.lerp(Kt.set(e.x, 2.6, e.z), Math.min(1, 1.3 * t)),
          (a.rotation.z += (0.22 - a.rotation.z) * Math.min(1, 2 * t)),
          (o.spot.intensity = THREE.MathUtils.lerp(
            o.spot.intensity,
            n.droneInspectIntensity * Ft,
            Math.min(1, 2 * t),
          )),
          Nt(a, 0),
          (o.inspectTimer -= t),
          o.inspectTimer <= 0 &&
            ((o.state = "patrol"), (o.cooldown = 5 + 7 * Math.random())));
      } else if ("hunt" === o.state) {
        const e = o.huntTarget;
        if (e && "hunted" === e.userData.state) {
          const i = e.position,
            s = Math.hypot(a.position.x - i.x, a.position.z - i.z),
            r = s < 2.6,
            c = r ? 2.3 : o.height;
          (a.position.lerp(
            Kt.set(i.x, c, i.z),
            Math.min(1, t * (r ? 1.6 : 2.4)),
          ),
            (a.rotation.z +=
              ((r ? 0 : 0.02) - a.rotation.z) * Math.min(1, 2 * t)),
            (o.spot.intensity = THREE.MathUtils.lerp(
              o.spot.intensity,
              n.droneInspectIntensity * Ft,
              Math.min(1, 2 * t),
            )));
          const l = r && a.position.y < 3 && s < 1;
          (Nt(a, l ? 1 : 0),
            l
              ? ((o.captureTimer += t),
                o.captureTimer > 1.6 &&
                  ((e.userData.state = "abducted"),
                  (e.userData.abductTimer = 0),
                  (function (t) {
                    f(700, 80, 0.35, "sawtooth", 0.09, t);
                  })(e.position),
                  (o.state = "patrol"),
                  (o.cooldown = 6 + 8 * Math.random()),
                  (o.huntTarget = null),
                  Nt(a, 0)))
              : (o.captureTimer = Math.max(0, o.captureTimer - 1.5 * t)),
            (o.huntTimer += t),
            o.huntTimer > 14 &&
              ((e.userData.state = "idle"),
              (o.state = "patrol"),
              (o.cooldown = 4 + 5 * Math.random()),
              Nt(a, 0)));
        } else
          ((o.state = "patrol"),
            (o.cooldown = 3 + 4 * Math.random()),
            Nt(a, 0));
      }
    });
    for (let t = 0; t < _t.length; t++)
      for (let e = t + 1; e < _t.length; e++) {
        const n = _t[t].position,
          a = _t[e].position,
          o = a.x - n.x,
          i = a.y - n.y,
          s = a.z - n.z,
          r = Math.sqrt(o * o + i * i + s * s);
        if (r < 1.1 && r > 1e-4) {
          const t = (1.1 - r) / 2,
            e = o / r,
            c = i / r,
            l = s / r;
          ((n.x -= e * t),
            (n.y -= c * t * 0.3),
            (n.z -= l * t),
            (a.x += e * t),
            (a.y += c * t * 0.3),
            (a.z += l * t));
        }
      }
  }
  // Se una foto non carica resta il riquadro colorato; il visitatore
  // vede un solo avviso, chiaro e senza dettagli tecnici.
  let imgErrShown = !1;
  function $t(t, e) {
    if (t.imageUrl) {
      const n = new THREE.TextureLoader();
      (n.setCrossOrigin("anonymous"),
        n.load(
          t.imageUrl,
          (n) => {
            ((n.encoding = THREE.sRGBEncoding), e && e(n));
          },
          void 0,
          (e) => {
            (console.error("Immagine NON caricata per", t.title, t.imageUrl, e),
              imgErrShown ||
                ((imgErrShown = !0),
                y(
                  "Some artwork previews didn't load. Tap a frame to see the piece and its details.",
                )));
          },
        ));
    }
    return (function (t) {
      const e = document.createElement("canvas");
      ((e.width = 512), (e.height = 640));
      const n = e.getContext("2d"),
        a = "#" + t.toString(16).padStart(6, "0");
      ((n.fillStyle = a), n.fillRect(0, 0, e.width, e.height));
      const o = n.createLinearGradient(0, 0, e.width, e.height);
      (o.addColorStop(0, "rgba(255,255,255,0.08)"),
        o.addColorStop(1, "rgba(0,0,0,0.12)"),
        (n.fillStyle = o),
        n.fillRect(0, 0, e.width, e.height));
      const i = new THREE.CanvasTexture(e);
      return ((i.encoding = THREE.sRGBEncoding), i);
    })(t.color);
  }
  // Le cornici-prodotto sono appese a 3 delle 4 pareti (la parete nord è
  // riservata al cartello di uscita). Con più di 3 prodotti, questa
  // funzione li distribuisce in blocchi consecutivi lungo ciascuna parete
  // (invece di sovrapporli tutti negli stessi 3 punti), spaziandoli
  // uniformemente. Si adatta automaticamente al numero di prodotti in `l`.
  function Qt(index, total) {
    const walls = [
        { axis: "x", fixed: -H / 2 + 0.05, ry: 0 }, // parete sud
        { axis: "z", fixed: -R / 2 + 0.05, ry: Math.PI / 2 }, // parete ovest
        { axis: "z", fixed: R / 2 - 0.05, ry: -Math.PI / 2 }, // parete est
      ],
      perWall = Math.ceil(total / walls.length),
      wallIndex = Math.min(walls.length - 1, Math.floor(index / perWall)),
      wall = walls[wallIndex],
      indexInWall = index - wallIndex * perWall,
      countInWall = Math.min(perWall, total - wallIndex * perWall),
      span = 24, // lunghezza utile della parete (margine dagli angoli)
      offset =
        countInWall <= 1
          ? 0
          : THREE.MathUtils.lerp(
              -span / 2,
              span / 2,
              indexInWall / (countInWall - 1),
            );
    return "x" === wall.axis
      ? { x: offset, z: wall.fixed, ry: wall.ry }
      : { x: wall.fixed, z: offset, ry: wall.ry };
  }
  const Jt = [],
    te = new THREE.Group();
  function ee(t, e) {
    const n = 512,
      a = Math.round(512 / e),
      o = document.createElement("canvas");
    ((o.width = n), (o.height = a));
    const i = o.getContext("2d");
    ((i.fillStyle = "#000000"), i.fillRect(0, 0, n, a));
    ((i.fillStyle = "#c0c0c0"),
      i.fillRect(6, 6, 500, a - 12),
      (i.fillStyle = "#ffffff"),
      i.fillRect(6, 6, 500, 2),
      i.fillRect(6, 6, 2, a - 12),
      (i.fillStyle = "#808080"),
      i.fillRect(6, a - 6 - 2, 500, 2),
      i.fillRect(504, 6, 2, a - 12));
    const s = 0.115 * a,
      r = i.createLinearGradient(10, 0, 502, 0);
    (r.addColorStop(0, "#0a1f9c"),
      r.addColorStop(1, "#3f8cd6"),
      (i.fillStyle = r),
      i.fillRect(10, 10, 492, s),
      (i.fillStyle = "#ffffff"),
      (i.font = `700 ${Math.round(0.62 * s)}px "Courier New", monospace`),
      (i.textBaseline = "middle"),
      i.fillText(t, 20, 10 + s / 2 + 1));
    const c = 0.72 * s,
      l = 502 - c - 6,
      d = 10 + (s - c) / 2;
    ((i.fillStyle = "#c0c0c0"),
      i.fillRect(l, d, c, c),
      (i.fillStyle = "#ffffff"),
      i.fillRect(l, d, c, 2),
      i.fillRect(l, d, 2, c),
      (i.fillStyle = "#808080"),
      i.fillRect(l, d + c - 2, c, 2),
      i.fillRect(l + c - 2, d, 2, c),
      (i.strokeStyle = "#141414"),
      (i.lineWidth = Math.max(2, 0.14 * c)),
      (i.lineCap = "round"),
      i.beginPath(),
      i.moveTo(l + 0.25 * c, d + 0.25 * c),
      i.lineTo(l + 0.75 * c, d + 0.75 * c),
      i.moveTo(l + 0.75 * c, d + 0.25 * c),
      i.lineTo(l + 0.25 * c, d + 0.75 * c),
      i.stroke());
    const h = new THREE.CanvasTexture(o);
    return ((h.encoding = THREE.sRGBEncoding), h);
  }
  const ne = new THREE.MeshStandardMaterial({ color: 1118481, roughness: 0.5 }),
    productCount = l.length; // calcolato prima del forEach: al suo interno
  // esiste già una variabile locale chiamata "l" (il materiale del poster)
  // che oscurerebbe l'array prodotti per l'intero blocco.
  (l.forEach((t, e) => {
    const n = Qt(e, productCount),
      a = 1.5 / (210 / 297),
      o = 1.59,
      i = a + 0.24 + 0.09,
      s = new THREE.MeshBasicMaterial({
        map: ee(t.windowName || "FILE.EXE", o / i),
        toneMapped: !1,
      }),
      r = new THREE.Mesh(new THREE.PlaneGeometry(o, i), s),
      c = new THREE.Mesh(new THREE.BoxGeometry(o, i, 0.04), ne);
    ((c.position.z = -0.02), (c.castShadow = !0));
    const l = new THREE.MeshStandardMaterial({
        map: $t(t, (t) => {
          ((l.map = t), (l.needsUpdate = !0));
        }),
        roughness: 0.6,
        toneMapped: !1,
      }),
      d = new THREE.Mesh(new THREE.PlaneGeometry(1.5, a), l);
    (d.position.set(0, -0.12, 0.035),
      (d.userData = { type: "artwork", index: e }),
      Jt.push(d));
    const h = new THREE.Group();
    (h.add(c),
      h.add(r),
      h.add(d),
      h.position.set(n.x, 1.9, n.z),
      (h.rotation.y = n.ry),
      te.add(h));
  }),
    v.add(te));
  const ae = new THREE.Group(),
    oe = new THREE.Mesh(
      new THREE.PlaneGeometry(1.6, 2.6),
      new THREE.MeshStandardMaterial({ color: 1710618, roughness: 0.5 }),
    );
  ((oe.userData = { type: "exit" }), Jt.push(oe));
  const ie = new THREE.Mesh(
    new THREE.PlaneGeometry(1, 0.25),
    new THREE.MeshBasicMaterial({
      map: (function (t) {
        const e = document.createElement("canvas");
        ((e.width = 512), (e.height = 128));
        const n = e.getContext("2d");
        ((n.fillStyle = "#111111"),
          n.fillRect(0, 0, e.width, e.height),
          (n.fillStyle = "#fafafa"),
          (n.font = "700 44px monospace"),
          (n.textAlign = "center"),
          (n.textBaseline = "middle"),
          n.fillText(t, e.width / 2, e.height / 2));
        const a = new THREE.CanvasTexture(e);
        return ((a.encoding = THREE.sRGBEncoding), a);
      })("EXIT"),
    }),
  );
  (ie.position.set(0, 1.55, 0.04),
    ae.add(oe),
    ae.add(ie),
    ae.position.set(0, 1.3, H / 2 - 0.12),
    (ae.rotation.y = Math.PI),
    v.add(ae));
  const se = new THREE.Vector3(e.spawn.x, e.eyeHeight, e.spawn.z);
  let re = 0,
    ce = 0;
  const le = document.getElementById("panel"),
    de = document.getElementById("exit-confirm");
  // Apre la conferma di uscita (dal tasto Exit o dal cartello EXIT).
  function openExit() {
    (de.classList.add("show"), setJoystick(!1), g());
  }
  let he = !1,
    Ee = null,
    pe = 0,
    me = 0,
    ue = 0,
    Me = 0,
    fe = 0;
  const we = e.lookSensitivity;
  (S.addEventListener("pointerdown", (t) => {
    !T ||
      le.classList.contains("open") ||
      de.classList.contains("show") ||
      ((he = !0),
      (Ee = t.pointerId),
      (pe = ue = t.clientX),
      (me = Me = t.clientY),
      (fe = performance.now()),
      S.setPointerCapture(t.pointerId));
  }),
    S.addEventListener("pointermove", (t) => {
      if (!he || t.pointerId !== Ee) return;
      const e = t.clientX - pe,
        n = t.clientY - me;
      // Al tocco si "trascina il mondo" (come Street View e Google Maps):
      // dito a destra = sguardo a sinistra. Col mouse resta come prima.
      const dir = "touch" === t.pointerType ? -1 : 1;
      ((pe = t.clientX),
        (me = t.clientY),
        (re -= dir * e * we),
        (ce -= dir * n * we),
        (ce = Math.max(-1.3, Math.min(1.3, ce))));
    }),
    S.addEventListener("pointerup", (t) => {
      if (t.pointerId !== Ee) return;
      he = !1;
      const e = Math.hypot(t.clientX - ue, t.clientY - Me),
        n = performance.now() - fe;
      e < 8 &&
        n < 400 &&
        (function (t, e) {
          const n = P.domElement.getBoundingClientRect(),
            a = ((t - n.left) / n.width) * 2 - 1,
            o = (-(e - n.top) / n.height) * 2 + 1;
          ge.setFromCamera({ x: a, y: o }, I);
          const i = ge.intersectObjects(Jt);
          if (!i.length) return;
          const s = i[0].object;
          "artwork" === s.userData.type
            ? (function (t) {
                const e = l[t];
                ((document.getElementById("p-num").textContent =
                  String(t + 1).padStart(2, "0") +
                  " / " +
                  String(l.length).padStart(2, "0")),
                  (document.getElementById("p-title").textContent = e.title),
                  (document.getElementById("p-meta").textContent = e.meta),
                  (document.getElementById("p-price").textContent = e.price),
                  (document.getElementById("p-view").href = e.url),
                  (ke = e.variantId || null),
                  (Be = e.url));
                // Foto dell'opera nel pannello.
                const img = document.getElementById("p-img");
                img &&
                  (e.imageUrl
                    ? ((img.src = e.imageUrl),
                      (img.alt = e.title),
                      (img.style.display = "block"))
                    : (img.style.display = "none"));
                const pc = document.getElementById("p-cart");
                pc && (pc.hidden = !0);
                // Disponibilità letta da Shopify: se esaurita, niente carrello.
                const avail = !1 !== e.available,
                  n = document.getElementById("p-add-cart");
                ((n.disabled = !avail),
                  (n.textContent = avail ? "Add to cart" : "Sold out"),
                  (le.scrollTop = 0),
                  le.classList.add("open"),
                  setJoystick(!1),
                  g());
              })(s.userData.index)
            : "exit" === s.userData.type && openExit();
        })(t.clientX, t.clientY);
    }));
  const ge = new THREE.Raycaster();
  const Te = document.getElementById("joystick-zone"),
    ye = document.getElementById("joystick-knob");
  let Re = !1,
    He = null,
    xe = { x: 0, y: 0 };
  function Se(t) {
    t.pointerId === He &&
      ((Re = !1),
      (xe = { x: 0, y: 0 }),
      (ye.style.transform = "translate(0,0)"));
  }
  function ve(t) {
    const e = Te.getBoundingClientRect(),
      n = e.left + e.width / 2,
      a = e.top + e.height / 2;
    let o = t.clientX - n,
      i = t.clientY - a;
    const s = Math.min(Math.hypot(o, i), 40),
      r = Math.atan2(i, o);
    ((o = Math.cos(r) * s),
      (i = Math.sin(r) * s),
      (ye.style.transform = `translate(${o}px, ${i}px)`),
      (xe.x = o / 40),
      (xe.y = i / 40));
  }
  (Te.addEventListener("pointerdown", (t) => {
    ((Re = !0), (He = t.pointerId), Te.setPointerCapture(t.pointerId), ve(t));
  }),
    Te.addEventListener("pointermove", (t) => {
      Re && t.pointerId === He && ve(t);
    }),
    Te.addEventListener("pointerup", Se),
    Te.addEventListener("pointercancel", Se));
  const Ie = { forward: !1, back: !1, left: !1, right: !1 };
  (document.addEventListener("keydown", (t) => {
    // Niente movimento prima di entrare o mentre si scrive nel campo email.
    if (!T || (t.target && /^(INPUT|TEXTAREA)$/.test(t.target.tagName))) return;
    ((("KeyW" !== t.code && "ArrowUp" !== t.code) || (Ie.forward = !0),
      ("KeyS" !== t.code && "ArrowDown" !== t.code) || (Ie.back = !0),
      ("KeyA" !== t.code && "ArrowLeft" !== t.code) || (Ie.left = !0),
      ("KeyD" !== t.code && "ArrowRight" !== t.code) || (Ie.right = !0)));
  }),
    document.addEventListener("keyup", (t) => {
      (("KeyW" !== t.code && "ArrowUp" !== t.code) || (Ie.forward = !1),
        ("KeyS" !== t.code && "ArrowDown" !== t.code) || (Ie.back = !1),
        ("KeyA" !== t.code && "ArrowLeft" !== t.code) || (Ie.left = !1),
        ("KeyD" !== t.code && "ArrowRight" !== t.code) || (Ie.right = !1));
    }));
  const Pe = new THREE.Clock(),
    be = new THREE.Vector3(),
    Ce = new THREE.Vector3();
  let Ge = 0,
    camYaw = 0,
    camPitch = 0,
    camBreath = 0;
  function ze() {
    const t = Math.min(Pe.getDelta(), 0.1);
    let n = 0,
      a = 0;
    (Ie.forward && (a -= 1),
      Ie.back && (a += 1),
      Ie.left && (n -= 1),
      Ie.right && (n += 1),
      Re && ((n += xe.x), (a += xe.y)));
    const o = Math.hypot(n, a);
    if (o > 0.001) {
      (o > 1 && ((n /= o), (a /= o)),
        be.set(-Math.sin(re), 0, -Math.cos(re)),
        Ce.set(Math.cos(re), 0, -Math.sin(re)));
      const i = e.moveSpeed * t;
      (se.addScaledVector(be, -a * i),
        se.addScaledVector(Ce, n * i),
        (Ge -= t),
        Ge <= 0 &&
          (w(0.06, 0.022 + 0.012 * Math.random(), 380 + 220 * Math.random()),
          (Ge = 0.42)));
    } else Ge = 0;
    const i = e.wallMargin;
    ((se.x = Math.max(-R / 2 + i, Math.min(R / 2 - i, se.x))),
      (se.z = Math.max(-H / 2 + i, Math.min(H / 2 - i, se.z))));
    (pt.forEach((t) => {
      const e = se.x - t.x,
        n = se.z - t.z,
        a = Math.hypot(e, n),
        // Raggio di evitamento ostacoli tarato sul raggio dei silos
        // di acciaio, con un margine di comfort per il visitatore.
        o = SILO_RADIUS + 0.35;
      a < o &&
        a > 1e-4 &&
        ((se.x = t.x + (e / a) * o), (se.z = t.z + (n / a) * o));
    }),
      I.position.copy(se));
    // Sguardo con inerzia: la camera insegue l'angolo voluto (re/ce) invece
    // di saltarci sopra. Indipendente dal frame rate.
    const kLook = 1 - Math.exp(-CINE.lookSmoothing * t);
    ((camYaw += (re - camYaw) * kLook),
      (camPitch += (ce - camPitch) * kLook),
      (I.rotation.y = camYaw),
      (I.rotation.x = camPitch));
    // Respiro: oscillazione verticale minima, solo da fermi.
    ((camBreath += t),
      o > 0.001 || (I.position.y += CINE.breath * Math.sin(1.1 * camBreath)));
  }
  let ke = null,
    Be = "#";
  function Le() {
    (le.classList.remove("open"), setJoystick(T), g());
  }
  (document.getElementById("p-add-cart").addEventListener("click", (t) =>
    (async function (t, e) {
      if (!t)
        return (
          console.warn(
            "variantId non configurato per questa opera — apro la pagina prodotto.",
          ),
          void window.open(Be, "_blank")
        );
      const n = e.textContent;
      ((e.disabled = !0), (e.textContent = "Adding…"));
      let ok = !1;
      try {
        const n = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: Number(t), quantity: 1 }] }),
        });
        if (!n.ok) throw new Error("status " + n.status);
        ((ok = !0), (e.textContent = "Added ✓"));
        const pc = document.getElementById("p-cart");
        pc && (pc.hidden = !1);
      } catch (t) {
        (console.error("Errore aggiunta al carrello:", t),
          (e.textContent = "Error — try again"));
      } finally {
        setTimeout(() => {
          ((e.disabled = !1), (e.textContent = ok ? "Add another" : n));
        }, 1800);
      }
    })(ke, t.currentTarget),
  ),
    document.getElementById("p-close").addEventListener("click", Le),
    document.getElementById("panel-close-x").addEventListener("click", Le),
    document.getElementById("exit-stay").addEventListener("click", () => {
      (de.classList.remove("show"), setJoystick(T), g());
    }),
    document.getElementById("exit-go").addEventListener("click", () => {
      (g(), de.classList.remove("show"), (window.location.href = c));
    }),
    document.getElementById("exit-btn").addEventListener("click", openExit),
    document.getElementById("mute-btn").addEventListener("click", function () {
      ((u = !u), p && (p.gain.value = u ? 0 : o.masterVolume));
      const t = document.getElementById("mute-btn");
      (t && (t.textContent = u ? "🔇" : "🔊"), u || g());
    }),
    document.addEventListener("keydown", (t) => {
      "Escape" === t.code &&
        (le.classList.remove("open"),
        de.classList.remove("show"),
        setJoystick(T));
    }),
    window.addEventListener("pageshow", (t) => {
      t.persisted &&
        (le.classList.remove("open"),
        de.classList.remove("show"),
        setJoystick(T));
    }),
    window.addEventListener("resize", () => {
      ((I.aspect = window.innerWidth / window.innerHeight),
        I.updateProjectionMatrix(),
        P.setSize(window.innerWidth, window.innerHeight));
    }));
  // --- Ciclo giorno/notte: sole, luna, cielo, nebbia, luminosità dei
  // pallini luminosi (bt) e velocità globale dei robot (jt/Ft). ---
  function updateDayNightCycle(elapsed) {
    const e =
        ((elapsed % a.cycleSeconds) / a.cycleSeconds) * Math.PI * 2 +
        Math.PI / 2,
      o = Math.sin(e),
      i = Math.max(0, o);
    (U.position.set(90 * Math.cos(e), 15 + 60 * Math.max(0, o), -40),
      (U.material.opacity = Math.max(0, Math.min(1, 4 * o))));
    const s = 1 - Math.min(1, 1.6 * Math.abs(o) + 0.3 * i);
    (kt.color.setRGB(1, 0.96 - 0.22 * s, 0.9 - 0.42 * s),
      kt.position.set(40 * Math.cos(e), Math.max(2, 10 + 46 * o), 12),
      kt.target.position.set(0, 0, 0),
      (kt.intensity = n.sunIntensity * i),
      v.background.copy(Ot).lerp(Vt, 1 - i),
      v.fog.color.copy(v.background),
      (zt.intensity = n.ambientIntensity * (0.32 + 0.68 * i)));
    const r = 1 - i,
      c = e + Math.PI,
      l = e + 0.72 * Math.PI;
    (Lt.position.set(70 * Math.cos(c), 15 + 50 * Math.max(0, Math.sin(c)), 30),
      Dt.position.set(
        55 * Math.cos(l),
        15 + 40 * Math.max(0, Math.sin(l)),
        -55,
      ),
      (Lt.material.opacity = Math.min(1, 2.2 * r) * Math.max(0, Math.sin(c))),
      (Dt.material.opacity = Math.min(1, 2.2 * r) * Math.max(0, Math.sin(l))),
      At.position.copy(Lt.position),
      At.target.position.set(0, 0, 0),
      Wt.position.copy(Dt.position),
      Wt.target.position.set(0, 0, 0),
      (At.intensity = a.moonIntensity * r * Math.max(0, Math.sin(c))),
      (Wt.intensity = 0.7 * a.moonIntensity * r * Math.max(0, Math.sin(l))),
      qt.set(16777215).lerp(Xt, 0.75 * r),
      bt.forEach((t) => t.material.color.copy(qt)),
      (jt = 0.15 + 0.85 * i),
      (Ft = 1 + 1.2 * r));
  }
  // --- Posizione/orientamento dell'ascoltatore audio 3D = camera. ---
  function updateAudioListener() {
    if (!E) return;
    const t = I.position,
      e = E.listener;
    e.positionX
      ? ((e.positionX.value = t.x),
        (e.positionY.value = t.y),
        (e.positionZ.value = t.z))
      : e.setPosition && e.setPosition(t.x, t.y, t.z);
    const n = -Math.sin(re) * Math.cos(ce),
      a = Math.sin(ce),
      o = -Math.cos(re) * Math.cos(ce);
    e.forwardX
      ? ((e.forwardX.value = n),
        (e.forwardY.value = a),
        (e.forwardZ.value = o),
        (e.upX.value = 0),
        (e.upY.value = 1),
        (e.upZ.value = 0))
      : e.setOrientation && e.setOrientation(n, a, o, 0, 1, 0);
  }
  // --- Stato dei fiori: crescita, abduzione da parte dei droni,
  // respawn e leggero movimento/ondeggiamento idle. ---
  function updateFlowers(elapsed, dt) {
    tt.forEach((n) => {
      const a = n.userData;
      if ("growing" === a.state) {
        a.growTimer = (a.growTimer || 0) + dt;
        const t = Math.min(1, a.growTimer / 0.9),
          o = t * t * (3 - 2 * t),
          i = a.baseScale * o;
        (n.scale.set(i, i, 1), t >= 1 && ((a.state = "idle"), (a.growTimer = 0)));
      } else if ("abducted" === a.state) {
        a.abductTimer += dt;
        const t = Math.min(1, a.abductTimer / 1.1);
        n.position.y = THREE.MathUtils.lerp(a.baseY, a.baseY + 4.6, t);
        const o = a.baseScale * (1 - 0.95 * t);
        (n.scale.set(o, o, 1),
          t >= 1 &&
            ((a.state = "respawning"), (a.respawnTimer = 3 + 3 * Math.random())));
      } else
        "respawning" === a.state
          ? ((a.respawnTimer -= dt),
            a.respawnTimer <= 0 &&
              (at(n),
              (n.material.map = J[Math.floor(Math.random() * J.length)]),
              n.scale.set(a.baseScale, a.baseScale, 1),
              (a.state = "idle"),
              (a.hunted = !1),
              (a.abductTimer = 0)))
          : ((n.material.rotation =
              Math.sin(elapsed * a.speed + a.phase) * a.rotAmt),
            (n.position.x =
              a.baseX +
              Math.sin(elapsed * a.speed * 0.7 + a.phase) * a.swayDist));
    });
  }
  const De = new THREE.Clock();
  let Ae = 0;
  function animate() {
    requestAnimationFrame(animate);
    const dt = Math.min(De.getDelta(), 0.1);
    Ae += dt;
    ze();
    updateDayNightCycle(Ae);
    updateAudioListener();
    bt.forEach((t) => {
      ((t.position.x += t.userData.speed * dt),
        t.position.x > 55 && (t.position.x = -55));
    });
    Gt.forEach((t) => {
      ((t.mesh.position.x = t.cloud.position.x),
        (t.mesh.position.z = t.cloud.position.z));
    });
    Zt(dt, Ae);
    updateFlowers(Ae, dt);
    ot.forEach((n) => n.update(Ae, dt));
    $(Ae, dt);
    P.render(v, I);
  }
  animate();
})();
